// import React from 'react'
// import {
//     FormControl, Grid, TextField, Box, Button,
//     Typography, Container, OutlinedInput, InputAdornment, Tooltip, Link,
//     IconButton, Input, Paper,
//     Autocomplete
// } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteIcon from '@mui/icons-material/Delete'
// import { Chip } from '@mui/material';
// import { useForm } from 'react-hook-form';
// import { useEffect, useState, useRef } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import { toast } from 'react-toastify';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import axiosInstance from '../../lib/axios';
// import PrintIcon from '@mui/icons-material/Print';
// import Flag from '../../Components/Ragistration/Booking/Flag';
// import moment from 'moment';
// import BokingCModal from '../../Components/Ragistration/BConfirmation/BokingCModal';
// import { useReactToPrint } from 'react-to-print';
// import BReport from '../../atoms/ReportFolder/BReport';
// import axiosInstanceForPG from '../../lib/axiosFormPG';
// import CircularProgress from '@mui/material/CircularProgress';
// import 'jspdf-autotable';
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import ConfirmationDialog from '../ReusableDailog';
// import { useSelector } from 'react-redux';
// import { selectGlobalProperty } from '../../redux/propertySlice';
// import CancelIcon from '@mui/icons-material/Cancel';
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import PrintCharges from './PrintCharges';
// import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
// import UnbuildAdvice from '../CheckoutRequest/UnbuildAdvice';


// const columns = [
//     { id: 'BookId', label: 'BookId', minWidth: 50 },
//     { id: 'BookNo', label: 'Booking No', minWidth: 120 },
//     { id: 'BookDt', label: 'Book Date', minWidth: 130 },
//     { id: 'BookSt', label: 'Status', minWidth: 130 },
//     { id: 'ResidentName', label: 'Resident', minWidth: 130 },
//     { id: 'MobileNo', label: 'Mobile', minWidth: 150 },
//     { id: 'Duration', label: 'Duration', minWidth: 100 },
//     { id: 'CheckinDt', label: 'CheckIn', minWidth: 100 },
//     { id: 'CheckoutDt', label: 'CheckOut', minWidth: 100 },
// ];

// function Checkoutdues(bookSt, onConfirm, bookId, onAccDetails, onAccGenerate) {
//     const { register, watch, setValue, reset } = useForm();
//     const navigate = useNavigate();
//     const [rows, setRows] = useState([]);
//     const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
//     const [OpenLoader, setOpenLoader] = useState(false);
//     const [TransactionData, setTransactionData] = useState([]);
//     const [OpenHistoryTableDialog, setOpenHistoryTableDialog] = useState(false);
//     const [AccGenerate, setAccGenerate] = useState(false);
//     const [BookId, setBookId] = useState(-1);
//     const [page, setPage] = useState(0);
//     const [isLoading, setIsLoading] = useState(false);
//     const [rowsPerPage, setRowsPerPage] = useState(8);
//     const [searchTerms, setSearchTerms] = useState({});
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [Mode, setMode] = useState('add');
//     const [loadingPaymentLinks, setLoadingPaymentLinks] = useState({});
//     const location = useLocation();
//     const contentRef = useRef(null);
//     const [hasUnpaidRent, setHasUnpaidRent] = useState(false);
//     const [switchState, setSwitchState] = useState(false);
//     const [emailResponse, setEmailResponse] = useState(null);
//     const [isBookingConfirmed, setIsBookingConfirmed] = useState(false);
//     const [isDepositPaid, setIsDepositPaid] = useState(false);
//     const [openCheckoutConfirm, setOpenCheckoutConfirm] = useState(false);
//     const [openCheckinConfirm, setOpenCheckinConfirm] = useState(false);
//     const handlePrint = useReactToPrint({ contentRef });
//     const globalProperty = useSelector(selectGlobalProperty);
//     const [showPayAdvice, setShowPayAdvice] = useState(false);
//     const baseUrl = window.location.origin;
//     const [payAdvice, setPayAdvice] = useState([]);
//     const [isCheckoutProcessing, setIsCheckoutProcessing] = useState(false);
//     const [selectedCheckoutDate, setSelectedCheckoutDate] = useState(new Date().toLocaleDateString('en-GB'));
//     const [isDataLoaded, setIsDataLoaded] = useState(false);
//     const [accountData, setAccountData] = useState([]);
//     const [oldBedId, setOldBedId] = useState('');
//     const [residentid, setResidentId] = useState(null);
//     const [propId, setPropId] = useState(null);
//     const [selectedData, setSelectedDate] = useState(new Date().toLocaleDateString('en-GB'));
//     const [minCheckInDate, setMinCheckInDate] = useState(null);
//     const [OthChrgDrp, setOthChrgDrp] = useState([]);
//     const [isRefOth, setIsRefOth] = useState(false);
//     const [amount, setAmount] = useState('');
//     const [remark, setRemark] = useState('');
//     const [discount, setDiscount] = useState('');
//     const [totalAmount, setTotalAmount] = useState('');
//     const [selectedCharge, setSelectedCharge] = useState(null);
//     const [otherChargesList, setOtherChargesList] = useState([]);
//     const [isPenaltyCalculated, setIsPenaltyCalculated] = useState(false);
//     const [checkoutSettlementData, setCheckoutSettlementData] = useState(null);
//     const [deletedCharges, setDeletedCharges] = useState([]);
//     const [isButtondisable, setIsButtondisable] = useState(false)
//      const [pendingAdvice, setPendingAdvice] = useState('')

//     useEffect(() => {
//         if (BookId !== -1 && !isCheckoutProcessing) {
//             fetchPayAdvice(BookId);
//             fetchPendingAdvice(BookId)
//         }
//     }, [BookId, isCheckoutProcessing]);

//     useEffect(() => {
//         // let MobileNo = location.state?.MobileNo;
//         let BookId = location?.state?.BookId
//         let ChkOutStlId = location?.state?.ChkOutStlId
//         if (BookId) {
//             // handleMobileChange(MobileNo, "B");
//             fetchTransactionData(BookId);
//         } else {
//             setMode("add");
//         }
//         const fetchApi = async () => {
//             setValue("CountryIcon", Flag);
//             setValue("BookDt", "");
//             setValue("BookDtFrom", "");
//             setValue("BookUpToDt", "");
//             // await fetchDataOfBooking();
//             if (ChkOutStlId) {
//                 await fetchOtherCharges(ChkOutStlId);
//             }
//         };
//         fetchApi();
//     }, [location.state?.BookId, location.state?.ChkOutStlId]);

//     const fetchTransactionData = async (bookId) => {
//         if (!bookId) return;

//         try {
//             setOpenLoader(true);
//             const response = await axiosInstance.post(`TrnBooking/RetriveTrnBooking`, {
//                 BookId: bookId,
//                 Flag: "R",
//                 CreatedBy: UserId
//             }
//             );

//             if (response.data.Status === 0) {
//                 setIsDataLoaded(true);
//                 const bookingData = response.data.Data[0];
//                 const {
//                     BookSt, PropId, ResidentId, RoomBedId, CheckedOutDt, MobileNo, ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, CheckoutDt,
//                     TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, CheckinDt, Email, PlanName, MonthlyAmt, BookStatus
//                 } = bookingData;
//                 setAccountData(bookingData);
//                 setOldBedId(RoomBedId);
//                 setResidentId(ResidentId);
//                 setPropId(PropId);
//                 setBookId(bookId);
//                 setValue("MobileNo", MobileNo);
//                 setValue("ResidentName", ResidentName);
//                 setValue("BookNo", BookNo);
//                 setValue("BookDt", BookDt);
//                 setValue("Duration", Duration);
//                 setValue("BookDtFrom", BookDtFrom);
//                 setValue("BookUpToDt", BookUpToDt);
//                 setValue("CheckoutDt", CheckoutDt);
//                 setValue("TopupAmt", TopupAmt);
//                 setValue("AdvcRcble", AdvcRcble);
//                 setValue("DiscAmt", DiscAmt);
//                 setValue("TotalRent", TotalRent);
//                 setValue("NetAmt", NetAmt);
//                 setValue("BedRent", BedRent);
//                 setValue("FreeMonth", FreeMonth);
//                 setValue("PropName", PropName);
//                 setValue("Email", Email);
//                 setValue("PlanName", PlanName);
//                 setValue("MonthlyAmt", MonthlyAmt);
//                 setValue("CheckinDt", CheckinDt)
//                 setValue('CheckedOutDt', CheckedOutDt)
//                 if (BookSt === "C") {
//                     setSelectedDate(CheckinDt);
//                 } else {
//                     const currentDate = new Date().toISOString()?.split("T")[0];
//                     const bookFromDateObj = new Date(BookDtFrom);
//                     const currentDateObj = new Date(currentDate);
//                     bookFromDateObj.setHours(0, 0, 0, 0);
//                     currentDateObj.setHours(0, 0, 0, 0);
//                     setSelectedDate(currentDateObj >= bookFromDateObj ? currentDate : BookDtFrom);
//                 }

//                 setMinCheckInDate(BookDtFrom);
//                 setAccGenerate(BookSt === "B");
//                 setTransactionData(response.data.Data);
//                 await fetchPayAdvice(bookId);
//                 await fetchPendingAdvice(bookId)
//                 await fetchRoomBedData(RoomBedId, BookDtFrom, BookUpToDt, PropId);
//                 await fetchServicesData(bookingData.TransPlanId, bookingData.MessPlanId);
//             } else {
//                 setIsDataLoaded(false);
//                 toast.info("Booking Not Found");
//                 resetFuncM();
//             }
//         } catch (error) {
//             toast.error("Failed to load booking data");
//         } finally {
//             setOpenLoader(false);
//         }
//     };

//     const fetchOtherCharges = async (ChkOutStlId) => {
//         if (!ChkOutStlId) return;
//         try {
//             setOpenLoader(true);
//             const response = await axiosInstance.post(`TrnChkOutStl/RetriveTrnChkOutStlAll`, {
//                 ChkOutStlId: ChkOutStlId,
//                 Flag: "R",
//             });

//             if (response.data.Status === 0) {
//                 setIsDataLoaded(true);
//                 setIsButtondisable(true);
//                 const mainData = response.data.Data.TrnChkOutStlDtlEntity[0];
//                 const chargesData = mainData?.trnChkOutStlDtlEntities || [];
//                 const apiCheckoutDate = mainData.ChkOutDt;
//                 let formattedCheckoutDate = '';
//                 const apiSettlementDate = mainData.ChkOutStlDt;
//                 if (apiCheckoutDate) {
//                     formattedCheckoutDate = dayjs(apiCheckoutDate).format('DD/MM/YYYY');
//                 } else {
//                     formattedCheckoutDate = dayjs().format('DD/MM/YYYY');
//                 }
//                 const checkoutSettlementData = {
//                     ChkOutStlId: mainData.ChkOutStlId,
//                     ChkOutStlNo: mainData.ChkOutStlNo,
//                     BookId: mainData.BookId,
//                     PropId: mainData.PropId,
//                     ResidentId: mainData.ResidentId,
//                     ChkOutDt: mainData.ChkOutDt,
//                     ChkOutBy: mainData.ChkOutBy,
//                     TotalChrgAmt: mainData.ChrgAmt,
//                     TotalDiscAmt: mainData.DiscAmt,
//                     TotalNetAmt: mainData.NetAmt,
//                     PytAdvId: mainData.PytAdvId,
//                     RefundAdvId: mainData.RefundAdvId,
//                     Status: mainData.Status,
//                     Remark: mainData.Remark,
//                     CreatedDt: mainData.CreatedDt,
//                     CreatedBy: mainData.CreatedBy,
//                     PropName: mainData.PropName,
//                     BookNo: mainData.BookNo,
//                     BookDt: mainData.BookDt,
//                     ResidentName: `${mainData.FirstName} ${mainData.MidName || ''} ${mainData.LastName}`.trim(),
//                     PytAdvNo: mainData.PytAdvNo,
//                     DBFLAG: mainData.DBFLAG
//                 };
//                 const formattedCharges = chargesData.map(charge => ({
//                     id: charge.ChkOutStlDtlId,
//                     chargeId: charge.OthChrgId,
//                     chargeName: charge.ChrgName,
//                     amount: parseFloat(charge.ChrgAmt) || 0,
//                     discount: parseFloat(charge.DiscAmt) || 0,
//                     netAmount: parseFloat(charge.NetAmt) || 0,
//                     ChkOutStlDtlId: charge.ChkOutStlDtlId,
//                     OthChrgId: charge.OthChrgId,
//                     ChrgAmt: charge.ChrgAmt,
//                     DiscAmt: charge.DiscAmt,
//                     NetAmt: charge.NetAmt,
//                     ChrgName: charge.ChrgName,
//                     remark: charge.Remark || '',
//                     DBFLAG: charge.DBFLAG
//                 }));
//                 setCheckoutSettlementData(checkoutSettlementData);
//                 setOtherChargesList(formattedCharges);
//                 if (formattedCharges.length > 0) {
//                     setIsPenaltyCalculated(true);
//                 }
//                 setValue("PropName", mainData.PropName);
//                 setValue("BookNo", mainData.BookNo);
//                 setValue("CheckedOutDt", formattedCheckoutDate);
//                 setValue("BookDt", mainData.BookDt);
//                 setValue("ResidentName", `${mainData.FirstName} ${mainData.MidName || ''} ${mainData.LastName}`.trim());
//                 setValue("Remark", mainData.Remark);
//             } else {
//                 setIsDataLoaded(false);
//                 setIsButtondisable(false);
//                 toast.info("Booking Not Found");
//                 resetFuncM();
//             }
//         } catch (error) {
//             toast.error("Failed to load booking data");
//         } finally {
//             setOpenLoader(false);
//         }
//     };
//     useEffect(() => {
//         fetchOtherCharges()
//     }, [])

//     const fetchPayAdvice = async (BookId) => {
//         try {
//             setOpenLoader(true);
//             const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
//                 "PytAdvDt": moment().format("YYYY-MM-DD"),
//                 "Flag": "GenPytAdv",
//                 "BookId": BookId
//             });

//             if (response.data.Status === 0) {
//                 setPayAdvice(response.data.Data);
//                 setShowPayAdvice(true);

//                 const unpaidRentExists = response.data.Data.some(
//                     item => item.PytAdvFor === "R" && item.IsDepPaid !== "Y"
//                 );
//                 const firstInstallmentPaid = response.data.Data.some(
//                     item => item.PytAdvFor === "R" &&
//                         item.Remark?.includes("Installment 1") &&
//                         item.IsDepPaid === "Y"
//                 );

//                 setHasUnpaidRent(unpaidRentExists && !firstInstallmentPaid);
//             }
//         } catch (error) {
//             toast.error('Error fetching payment advice:', error);
//         } finally {
//             setOpenLoader(false);
//         }
//     };

//         const fetchPendingAdvice = async (BookId) => {
//             console.log('BookId', BookId)
//             try {
//                 setOpenLoader(true);
//                 const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
//                     "PytAdvDt": moment().format("YYYY-MM-DD"),
//                     "Flag": "UnBilledAdvPyt",
//                     "BookId": BookId
//                 });

//                 if (response.data.Status === 0) {
//                     setPendingAdvice(response.data.Data);
//                     setShowPayAdvice(true);

//                     const unpaidRentExists = response.data.Data.some(
//                         item => item.PytAdvFor === "R" && item.IsDepPaid !== "Y"
//                     );
//                     const firstInstallmentPaid = response.data.Data.some(
//                         item => item.PytAdvFor === "R" &&
//                             item.Remark?.includes("Installment 1") &&
//                             item.IsDepPaid === "Y"
//                     );

//                     setHasUnpaidRent(unpaidRentExists && !firstInstallmentPaid);
//                 }
//             } catch (error) {
//                 toast.error('Error fetching payment advice:', error);
//             } finally {
//                 setOpenLoader(false);
//             }
//         };

//     useEffect(() => {
//         if (TransactionData.length > 0) {
//             const { MobileNo, ResidentName, CheckinDt, BookNo, CheckoutDt, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, BookId, PropName, Email, PropId } = TransactionData[0];
//             let obj = { ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, MobileNo, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, Email, CheckinDt, PropId }

//             setValue("MonthlyAmt", Math.round(NetAmt / Duration));
//             setObjValue(obj);
//             setValue("Email", Email);
//             setValue("PropId", PropId);
//             setValue("CheckinDt", CheckinDt)
//             setBookId(BookId)
//             const fetchDataAndSet = async () => {
//                 await fetchRoomBedData(TransactionData[0].RoomBedId, TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, TransactionData[0].PropId);
//                 await fetchPlanData(TransactionData[0].RoomPlanId);
//                 await fetchServicesData(TransactionData[0].TransPlanId, TransactionData[0].MessPlanId);
//             }
//             fetchDataAndSet();
//             setNetAmount();
//         }
//     }, [TransactionData, globalProperty]);

//     useEffect(() => {
//         const today = dayjs();
//         const formattedToday = today.format('DD/MM/YYYY');
//         setValue('CheckoutDt', formattedToday);
//         setSelectedCheckoutDate(formattedToday);
//     }, []);

//     const handleSearchChange = (columnId, value) => {
//         setSearchTerms(prev => ({ ...prev, [columnId]: value }));
//         setPage(0);
//     };
//     const handleChangePage = (event, newPage) => {
//         setPage(newPage);
//     };

//     const handleChangeRowsPerPage = (event) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     };
//     const filteredRows = React.useMemo(() => {
//         return rows.filter(row => {
//             return Object.entries(searchTerms).every(([columnId, term]) => {
//                 if (!term) return true;
//                 const value = row[columnId];
//                 if (typeof value === 'string') {
//                     return value.toLowerCase().includes(term.toLowerCase());
//                 } else if (typeof value === 'number') {
//                     return value.toString().includes(term);
//                 }
//                 return true;
//             });
//         });
//     }, [searchTerms, rows]);

//     const fetchDataOfBooking = async () => {
//         try {
//             setIsPenaltyCalculated(false)
//             const response = await axiosInstance.post(
//                 `TrnBooking/GetTrnBookingDashBoard`,
//                 {
//                     PageNumber: 1,
//                     PageSize: 0,
//                     SearchText: '',
//                     Flag:'PendChkStl',
//                     MobileNo :'',
//                     BookNo:'',
//                     PropId:globalProperty,
//                 }
//             );

//             if (response.data.Status === 0) {
//                 const formattedData = response.data.Data.map(checkout => ({
//                     ...checkout,
//                     BookSt: checkout.BookSt === "O" ? "CheckedIn" : checkout.BookSt === "X" ? "Cancel" : ""
//                 }));
//                 setRows(formattedData);
//             } else {
//                 toast.error('Error fetching Grid data:', response.data.Message);
//                 setRows([]);
//             }
//         } catch (error) {
//             toast.error('Error fetching Booking data:', error);
//         }
//     };

//     const handleMobileChange = async (e, Separator) => {
//         let val = "";
//         if (Separator === "A") {
//             val = e.target.value.trim()
//         } else {
//             val = e.trim();
//         }

//         if (val.length >= 10) {
//             try {
//                 setIsPenaltyCalculated(false)
//                 const response = await axiosInstance.post(
//                     `TrnBooking/GetTrnBookingDashBoard`,
//                     {
//                         "start": 1,
//                         "PageSize": 1,
//                         "SearchText": 'PendChkStl',
//                         "Flag":'',
//                         "MobileNo" :val,
//                         "BookNo":'',
//                         "PropId":1,
//                     }
//                 );

//                 if (response.data.Status === 0) {
//                     setIsDataLoaded(true);
//                     const { BookSt, IsDepPaid } = response.data.Data[0];
//                     const data = response.data.Data[0]
//                     setAccountData(data);
//                     setIsDepositPaid(IsDepPaid === "Y");
//                     setIsBookingConfirmed(BookSt === "O");
//                     setSwitchState(BookSt === "O");
//                     if (BookSt === "B") {
//                         setAccGenerate(false);
//                     } else {
//                         setAccGenerate(true);
//                     }
//                     setTransactionData(response.data.Data);
//                     setOtherChargesList([]);
//                     await fetchPayAdvice(response.data.Data[0].BookId);
//                     await fetchPendingAdvice(response.data.Data[0].BookId);
//                 } else {
//                     setIsDataLoaded(false);
//                     toast.info("Booking Doesn't Exist On This Number");
//                     resetFuncM();
//                     setValue("BookNo", "");
//                     setBookId(-1);
//                 }
//             } catch (error) {
//                 toast.error('Error fetching data:', error);
//             }
//         } else if (val.length === 9) {
//             resetFuncM();
//             setValue("BookNo", "");
//             setBookId(-1);
//         }
//         Separator === "B" && handleClose();
//     };

//     const handleBookNoChange = async (e, Separator) => {
//         let val = "";
//         if (Separator === "A") {
//             val = e.target.value.trim()
//         } else {
//             val = e.trim();
//         }

//         if (val.length >= 8) {
//             try {
//                 setIsPenaltyCalculated(false)
//                 const response = await axiosInstance.post(
//                     `TrnBooking/GetTrnBookingDashBoard`,
//                     {
//                         "start": 1,
//                         "PageSize": 1,
//                         "SearchText": 'PendChkStl',
//                         "Flag":'',
//                         "MobileNo" :'',
//                         "BookNo":val,
//                         "PropId":1,
//                     }
//                 );

//                 if (response.data.Status === 0) {
//                     setIsDataLoaded(true);
//                     setIsButtondisable(true)
//                     const { BookSt, IsDepPaid } = response.data.Data[0];
//                     setIsDepositPaid(IsDepPaid === "Y");
//                     setIsBookingConfirmed(BookSt === "O");
//                     setSwitchState(BookSt === "O");

//                     if (BookSt === "B") {
//                         setAccGenerate(true);

//                     } else {
//                         setAccGenerate(false);
//                     }
//                     setTransactionData(response.data.Data);
//                     setOtherChargesList([]);
//                     await fetchPayAdvice(response.data.Data[0].BookId);
//                      await fetchPendingAdvice(response.data.Data[0].BookId);
//                 } else {
//                     setIsButtondisable(false)
//                     toast.info("Booking Doesn't Exist On This Number");
//                     resetFuncM();
//                     setValue("MobileNo", "");
//                     setBookId(-1);
//                 }
//             } catch (error) {
//                 setIsButtondisable(false)
//                 toast.error('Error fetching Booking data:', error);
//             }
//         } else if (val.length === 7) {
//             setIsDataLoaded(false);
//             resetFuncM();
//             setValue("MobileNo", "");
//         }
//         Separator === "B" && handleClose();
//     }

//     const fetchRoomBedData = async (RoomBedId, date1, date2, PropId) => {
//         try {
//             const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
//                 BookFromDt: date1,
//                 BookToDt: date2,
//                 PropId: PropId,
//                 Flag: "",
//                 RoomBedId: RoomBedId
//             });

//             if (response.data.Status === 0) {
//                 handleRowDoubleClick(response.data.Data[0]);
//             }
//         } catch (error) {
//             toast.error('Error fetching company data:', error);
//         }
//     };

//     const fetchPlanData = async (PlanId) => {
//         try {
//             const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
//                 "RoomPlanID": PlanId,
//                 "Flag": "R"
//             });

//             if (response.data.Status === 0) {
//                 setPlanData(response.data.Data);
//             }
//         } catch (error) {
//             toast.error('Error fetching company data:', error);
//         }
//     };

//     const handleRowDoubleClick = async (row) => {
//         const { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, } = row;
//         const obj = { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, };
//         setObjValue(obj);
//     };

//     const setPlanData = (PlanArr) => {
//         const { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt } = PlanArr[0];
//         const obj = { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt };
//         setObjValue(obj);
//     }


//     const setObjValue = (obj) => {
//         for (let key in obj) {
//             setValue(key, obj[key]);
//         }
//     }

//     const handleClose = () => {
//         setOpenHistoryTableDialog(false);
//         setPage(0);
//         setTimeout(() => {
//             setSearchTerms({});
//         }, [500]);

//     };

//     const handleClickCheckAva = async () => {
//         await fetchDataOfBooking();
//         setOpenHistoryTableDialog(true);
//     };

//     const setNetAmount = () => {
//         setValue("TotalAmt", ((watch("TAmount") || 0) + (watch("MAmount") || 0) + (watch("TopupAmt") || 0) + (watch("AdvcRcble") || 0)));
//     };

//     const fetchServicesData = async (TransPlanId, MessPlanId) => {
//         const Flag = "";
//         try {
//             const response = await axiosInstance.post(
//                 `MstTransPlan/getMstTransPlandrp`,
//                 { Flag, UserId },
//             );

//             if (response.data.Status === 0) {
//                 // setTransPlanDrp(response.data.Data);
//                 let obj = response.data.Data.find(obj => obj.TransPlanID === TransPlanId);
//                 if (obj) {
//                     setValue("TAmount", obj.Amount);
//                 } else {
//                     setValue("TAmount", 0);
//                 }
//                 setNetAmount()
//             } else {
//                 toast.error('Error fetching Trans data');
//             }
//         } catch (error) {
//             toast.error('Error fetching property data');
//         }
//         try {
//             const response = await axiosInstance.post(
//                 `MstMessPlan/getMstMessPlandrp`,
//                 { Flag, UserId },
//             );

//             if (response.data.Status === 0) {

//                 let obj = response.data.Data.find(obj => obj.MessPlanID === MessPlanId);
//                 if (obj) {
//                     setValue("MAmount", obj.Amount);
//                 } else {
//                     setValue("MAmount", 0);
//                 }
//                 setNetAmount();
//             } else {
//             }
//         } catch (error) {
//             toast.error('Error fetching Plan data');
//         }
//     }
//     const resetFuncM = () => {
//         const obj = {
//             "ResidentName": "",
//             "BookDt": "",
//             "Duration": "",
//             "BookDtFrom": "",
//             "BookUpToDt": "",
//             "WingName": "",
//             "FloorName": "",
//             "RoomTypeName": "",
//             "RoombedName": "",
//             "RoomBedTypeName": "",
//             "BedRent": "",
//             "PlanName": "",
//             "PlanTenur": "",
//             "FreeMonth": "0",
//             "LastAdjMonths": "0",
//             "IncRentPerc": "",
//             "DepositAmt": "",
//             "TopupAmt": "",
//             "Tamt": "",
//             "MAmount": "",
//             "TAmount": "",
//             "TotalRent": "",
//             "DiscAmt": "",
//             "NetAmt": "",
//             "MonthlyAmt": "",
//             "PropName": "",
//             "CheckedOutDt": dayjs().format('DD/MM/YYYY'),
//         }
//         for (let key in obj) {
//             setValue(key, "")
//         }
//         setValue("CountryIcon", Flag);
//         setSelectedCharge(null);
//         setAmount('');
//         setRemark('')
//         setDiscount('');
//         setTotalAmount('');
//         setOtherChargesList([]);
//         setIsSubmitting(false);
//         setSelectedCheckoutDate(dayjs().format('DD/MM/YYYY'));
//     };



//     const handleCheckoutConfirm = async () => {
//         setOpenLoader(true);
//         setOpenCheckoutConfirm(false);
//         setIsCheckoutProcessing(true);

//         try {
//             const checkoutDate = watch('CheckedOutDt');
//             const formattedDate = dayjs(checkoutDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
//             const response = await axiosInstance.post(
//                 `TrnBooking/TrnBookingConfirmation`,
//                 {
//                     "BookId": BookId,
//                     "CreatedBy": UserId,
//                     "Flag": "L",
//                     // "CreatedDate": TransactionData[0].CheckoutDt
//                     "CreatedDate": formattedDate,
//                 },
//             );

//             if (response.data.Status === 0) {
//                 toast.success("CheckOut Successfully");
//                 setTransactionData(prevData =>
//                     prevData.map(item => ({
//                         ...item,
//                         BookSt: "L"
//                     }))
//                 );
//                 setSwitchState(false);
//                 setIsBookingConfirmed(false);
//             } else {
//                 toast.error(response.data.Message || "Operation failed");
//             }
//         } catch (error) {
//             toast.error('Error fetching CheckIn data');
//         } finally {
//             setOpenLoader(false);
//             setIsCheckoutProcessing(false);
//         }
//     };

//     const handleCheckInClick = () => {
//         if (BookId === -1) {
//             toast.info("Nothing Any Transaction Is Visible");
//             return;
//         }

//         setOpenCheckinConfirm(true);
//     };

//     const handleCheckinConfirm = async () => {
//         setOpenLoader(true);
//         setOpenCheckinConfirm(false);

//         try {
//             const response = await axiosInstance.post(
//                 `TrnBooking/TrnBookingConfirmation`,
//                 {
//                     "BookId": BookId,
//                     "CreatedBy": UserId,
//                     "Flag": "O"
//                 },
//             );

//             if (response.data.Status === 0) {
//                 toast.success("Checkout Cancel Successfully");
//                 setTransactionData(prevData =>
//                     prevData.map(item => ({
//                         ...item,
//                         BookSt: "O"
//                     }))
//                 );
//                 setSwitchState(true);
//                 setIsBookingConfirmed(true);

//                 await fetchPayAdvice(BookId);
//                 await fetchPendingAdvice(BookId)

//             } else {
//                 toast.error(response.data.Message || "Operation failed");
//             }
//         } catch (error) {
//             toast.error('Error fetching CheckIn data');
//         } finally {
//             setOpenLoader(false);
//         }
//     };

//     const formatDate = (date) => {
//         if (!date || !moment(date).isValid()) return '';
//         return moment(date).format('DD/MM/YYYY');
//     };
//     const handleSendPaymentLink = async (item) => {
//         try {
//             setIsLoading(true);
//             setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: true }));
//             const userId = parseInt(sessionStorage.getItem('UserId'));
//             const paymentDetails = {
//                 purpose: item.Remark,
//                 amount: item.Amount,
//                 buyer_name: item.ResidentName,
//                 email: item.Email || "",
//                 phone: item.MobileNo,
//                 redirect_url: `${baseUrl}/payment-success`,
//                 redirecturl: `${baseUrl}/payment-success/`,
//                 webhook_url: '',
//                 ResidentId: item.ResidentId,
//                 TrjDocId: item.BookId,
//                 TrjType: "pytAdvice",
//                 TrjDocNo: item.PytAdvNo,
//             };

//             const response = await axiosInstanceForPG.post(
//                 `Payment/CreatePaymentOrder`,
//                 paymentDetails,
//             );

//             let paymentResponse = JSON.parse(response.data);
//             setEmailResponse(paymentResponse.payment_request.longurl);
//             const paymentLogPayload = {
//                 id: paymentResponse.payment_request.id,
//                 phone: paymentResponse.payment_request.phone,
//                 email: paymentResponse.payment_request.email,
//                 buyer_name: paymentResponse.payment_request.buyer_name,
//                 amount: paymentResponse.payment_request.amount,
//                 purpose: paymentResponse.payment_request.purpose,
//                 expires_at: paymentResponse.payment_request.expires_at,
//                 status: paymentResponse.payment_request.status,
//                 send_sms: paymentResponse.payment_request.send_sms,
//                 send_email: paymentResponse.payment_request.send_email,
//                 sms_status: paymentResponse.payment_request.sms_status,
//                 email_status: paymentResponse.payment_request.email_status,
//                 shorturl: paymentResponse.payment_request.shorturl,
//                 longurl: paymentResponse.payment_request.longurl,
//                 redirect_url: paymentResponse.payment_request.redirect_url,
//                 webhook: paymentResponse.payment_request.webhook,
//                 allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
//                 created_at: paymentResponse.payment_request.created_at,
//                 modified_at: paymentResponse.payment_request.modified_at,
//                 ResidentId: item.ResidentId,
//                 TrjDocNo: item.PytAdvNo,
//                 TrjDocId: item.PytAdvId,
//                 TrjType: "TrnPytAdv",
//                 Flag: "Active",
//                 Remark: "Payment Link for Payment Advice"
//             };
//             await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload);

//             const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${item.PytAdvNo}]`;
//             const Body = `Hey <strong>${item.ResidentName}</strong>,<br><br>
//             We would like to inform you that payment advice has been created for you tenancy at <strong>${item.PropName}</strong>.Please find attached your payment advice with this email <br><br>
//             Following are the details : <br><br>
//             Advice No: <strong>${item.PytAdvNo}</strong><br>
//             Amount: <strong>${item.Amount}</strong><br>
//             Date Of Issue: <strong>${formatDate(item.PytAdvDt)}</strong><br>
//             Due Date: <strong>${formatDate(item.DueDt)}</strong><br>
//             Advice For: <strong>${item.Remark}</strong><br>
//             <strong>Payment Link:</strong> <a href="${paymentResponse.payment_request.longurl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
//             We hope you are having a pleasant stay with us. Do let us know if you need any assitance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
//             Cheers,<br>
//             Team Clanbridge`;

//             const emailRequest = {
//                 ToEmail: item.Email ? [item.Email] : [],
//                 Subject,
//                 Body,
//                 Attachments: '',
//                 attachmentFilePaths: [],
//                 PropId: item.PropId,
//                 UserId: userId,
//             };
//             const emailResponse = await axiosInstanceForPG.post(
//                 `EmailRequest/SendEmail`,
//                 emailRequest,
//             );

//             if (emailResponse.data.Status === 0) {
//                 toast.success(`Payment Link Sent Successfully for ${item.PytAdvNo}`);
//             } else {
//                 toast.info(emailResponse.data.Message);
//             }
//             // fetchPayAdvice(activeView === 'advice' ? 'GenPytAdv' : 'BookingWise');
//         } catch (error) {
//             toast.error("Failed to send payment link");
//         } finally {
//             setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
//             setIsLoading(false);
//         }
//     };


//     useEffect(() => {
//         if (watch("OthChrgId") && OthChrgDrp.length > 0) {
//             const foundCharge = OthChrgDrp.find(charge => charge.Id === parseInt(watch("OthChrgId")));
//             if (foundCharge) {
//                 setSelectedCharge(foundCharge);
//             }
//         }
//     }, [OthChrgDrp, watch("OthChrgId")]);
//     const fetchOthCharges = async () => {
//         setIsRefOth(true);
//         try {
//             const response = await axiosInstance.post(`MstOthChrg/GetMstOthChrgDrp`);
//             if (response.data?.Data) {
//                 const mappedChargeData = response.data.Data.map((item) => ({
//                     Id: item.OthChrgId,
//                     Name: item.ChrgName,
//                 }));
//                 setOthChrgDrp(mappedChargeData);
//             } else {
//                 toast.error("Failed to fetch Other Charges");
//             }
//         } catch (error) {
//             console.error("Error fetching Other Charges:", error);
//             toast.error("Error fetching Other Charges.");
//         } finally {
//             setTimeout(() => {
//                 setIsRefOth(false);
//             }, 300);
//         }
//     };

//     useEffect(() => {
//         fetchOthCharges();
//     }, []);
//     const openOth = () => {
//         window.open("/othercharges");
//     }
//     useEffect(() => {
//         const amt = parseFloat(amount) || 0;
//         const disc = parseFloat(discount) || 0;
//         const calculatedTotal = amt - disc;
//         setTotalAmount(calculatedTotal > 0 ? calculatedTotal : 0);
//     }, [amount, discount]);

//     const handleChargeChange = (event, newValue) => {
//         setSelectedCharge(newValue);
//         setValue("OthChrgId", newValue?.Id || "");
//     };
//     const handleAddCharge = () => {
//         if (!selectedCharge) {
//             toast.error("Please select a charge first");
//             return;
//         }

//         const chargeExists = otherChargesList.some(item =>
//             item.chargeId === selectedCharge.Id ||
//             item.OthChrgId === selectedCharge.Id
//         );
//         if (chargeExists) {
//             toast.error("This charge has already been added");
//             return;
//         }
//         const newCharge = {
//             id: Date.now(),
//             chargeId: selectedCharge.Id,
//             chargeName: selectedCharge.Name,
//             amount: (amount),
//             discount: (discount) || 0,
//             netAmount:(totalAmount) || 0,
//             isNegative: false,
//             remark: remark || '',
//             DBFLAG: "+"
//         };
//         console.log('newCharge',newCharge)
//         setOtherChargesList(prev => [...prev, newCharge]);
//         setSelectedCharge(null);
//         setAmount('');
//         setRemark('')
//         setDiscount('');
//         setRemark('');
//         setTotalAmount('');
//         setIsPenaltyCalculated(false);
//     };

//     const handleDeleteCharge = (id) => {
//         setOtherChargesList(prev => {
//             const chargeToDelete = prev.find(item => item.id === id);
//             if (chargeToDelete && chargeToDelete.ChkOutStlDtlId) {
//                 setDeletedCharges(prevDeleted => [...prevDeleted, {
//                     ...chargeToDelete,
//                     DBFLAG: "D"
//                 }]);
//             }

//             return prev.filter(item => item.id !== id);
//         });
//         toast.success("Charge removed from list");
//     };
//     const totalChargesAmount = otherChargesList?.reduce((sum, item) => {
//         const netAmount = item.NetAmt !== undefined ? parseFloat(item.NetAmt) : parseFloat(item.netAmount || 0);

//         const isNegative = item.DBFLAG === "-" || item.isNegative || netAmount < 0;

//         if (isNegative) {
//             return sum - Math.abs(netAmount);
//         } else {
//             return sum + Math.abs(netAmount);
//         }
//     }, 0);

//     const handleCalculateCharges = async () => {
//         const payload = {
//             "BookId": BookId,
//             "Flag": "",
//             "PenaltyAmt": 0
//         }
//         try {
//             const response = await axiosInstance.post(`TrnBooking/CalcPenalty`, payload);
//             if (response.data.Status === 0 && response.data.Data) {
//                 const penaltyCharges = response.data.Data
//                     .filter(item => item.Amount !== 0)
//                     .map((item, index) => {
//                         const isNegative = item.DBFLAG === "-" || parseFloat(item.Amount) < 0;
//                         const amountValue = Math.abs(parseFloat(item.Amount)) || 0;
//                         return {
//                             id: `${index}-${Date.now()}`,
//                             chargeId: item.OthChrgId || '0',
//                             chargeName: item.ChrgName || (isNegative ? "Refund" : "Charge"),
//                             amount: amountValue,
//                             discount: 0,
//                             netAmount: isNegative ? -amountValue : amountValue,
//                             originalAmount: parseFloat(item.Amount),
//                             DBFLAG: item.DBFLAG,
//                             isNegative: isNegative
//                         };
//                     });
//                 if (penaltyCharges?.length > 0) {
//                     const newPenaltyCharges = penaltyCharges.filter(newCharge =>
//                         !otherChargesList.some(existingCharge =>
//                             existingCharge.chargeId === newCharge.chargeId &&
//                             existingCharge.DBFLAG === newCharge.DBFLAG &&
//                             existingCharge.isNegative === newCharge.isNegative
//                         )
//                     );

//                     if (newPenaltyCharges.length > 0) {
//                         setOtherChargesList(prev => [...prev, ...newPenaltyCharges]);
//                         setIsPenaltyCalculated(true);
//                     } else {
//                         toast.info("All charges are already added");
//                     }
//                 } else {
//                     toast.info("No charges found");
//                 }
//             } else {
//                 toast.error("No penalty data found");
//             }
//         } catch (error) {
//             console.error("Error calculating penalty:", error);
//             toast.error("Error calculating charges");
//         }
//     }

//     const handleSubmitdata = async () => {
//         if (isSubmitting) return;
//         const articleLossChargeId = 2;
//         const hasArticleDamage = TransactionData &&
//             TransactionData.length > 0 &&
//             TransactionData[0]?.ChkArtId > 0;

//         const hasArticleChargeAdded = otherChargesList.some(charge =>
//             charge.chargeId === articleLossChargeId
//         );

//         if (hasArticleDamage && !hasArticleChargeAdded) {
//             toast.error("Please add 'Articles checkout handover and Artical Loss & Damage Charges' before submitting");
//             return;
//         }


//         setIsSubmitting(true);
//         const chargesEntities = otherChargesList.map(charge => {
//             const dbFlag = charge.ChkOutStlDtlId ? "U" : "I";

//             return {
//                 "DBFLAG": dbFlag,
//                 "ChkOutStlDtlId": charge.ChkOutStlDtlId || 0,
//                 "ChkOutStlId": checkoutSettlementData?.ChkOutStlId || 0,
//                 "OthChrgId": charge.chargeId === '0' ? '5' : charge.chargeId,
//                 "ChrgAmt": charge.amount || charge.ChrgAmt || 0,
//                 "DiscAmt": charge.discount || 0,
//                 "NetAmt": charge.netAmount || charge.NetAmt || 0
//             };
//         });

//         const deletedChargesEntities = deletedCharges.map(charge => ({
//             "DBFLAG": "D",
//             "ChkOutStlDtlId": charge.ChkOutStlDtlId || 0,
//             "ChkOutStlId": checkoutSettlementData?.ChkOutStlId || 0,
//             "OthChrgId": charge.chargeId === '0' ? '5' : charge.chargeId,
//             "ChrgAmt": charge.amount || charge.ChrgAmt || 0,
//             "DiscAmt": charge.discount || 0,
//             "NetAmt": charge.netAmount || charge.NetAmt
//         }));

//         const allChargesEntities = [...chargesEntities, ...deletedChargesEntities];

//         const mainDBFlag = checkoutSettlementData?.ChkOutStlId ? "U" : "I";
//         const actualCheckoutDate = watch('ChkOutDt');
//         let formattedCheckoutDate = '';

//         if (actualCheckoutDate) {
//             formattedCheckoutDate = dayjs(actualCheckoutDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
//         } else {
//             formattedCheckoutDate = dayjs().format('YYYY-MM-DD');
//         }

//         const payload = {
//             "DBFLAG": mainDBFlag,
//             "ChkOutStlId": checkoutSettlementData?.ChkOutStlId || 0,
//             "BookId": BookId,
//             "PropId": propId || TransactionData[0]?.PropId || 0,
//             "ResidentId": residentid || TransactionData[0]?.ResidentId || 0,
//             "ChkOutDt": formattedCheckoutDate,
//             "ChkOutStlDt": formattedCheckoutDate,
//             "ChkOutBy": parseInt(UserId),
//             "PytAdvId": TransactionData[0]?.PytAdvId || 1,
//             "RefundAdvId": 1,
//             "Remark": "Api test",
//             "Status": "1",
//             "Created_By": parseInt(UserId),
//             "trnChkOutStlDtlEntities": allChargesEntities
//         };

//         try {
//             const response = await axiosInstance.post(`TrnChkOutStl/MangeTrnChkOutStl`, payload);
//             if (response.data.Status === 0) {
//                 toast.success(response.data.Message);
//                 setCheckoutSettlementData(null);
//                 setDeletedCharges([]);
//             } else {
//                 toast.error(response.data.Message || "Operation failed");
//                 setIsSubmitting(false);
//             }
//         } catch (error) {
//             toast.error('Error submitting checkout settlement');
//             console.error('Submission error:', error);
//             setIsSubmitting(false);
//         }
//     };

//     const handleCalculate = async () => {
//         const payload = {
//             "BookId": BookId,
//             "ResidentId": residentid || TransactionData[0]?.ResidentId || 0,
//             "PropId": propId || TransactionData[0]?.PropId,
//             "Amount": Math.abs(totalChargesAmount),
//             "CreatedBy": parseInt(UserId),
//             "Flag": ""
//         }
//         try {

//             const response = await axiosInstance.post(`TrnBooking/InsertCalcPenalty`, payload);
//             if (response.data.Status === 0 && response.data.Data) {
//                 toast.success('Settelment Calculated Successfully')
//                 await fetchPayAdvice(BookId);
//                 await fetchPendingAdvice(BookId)
//             } else {
//                 toast.error("No penalty data found");
//             }
//         } catch (error) {
//             console.error("Error calculating penalty:", error);
//             toast.error("Error calculating penalty charges");
//         }
//     }
//     const handleExitClick = () => {
//         navigate('/checkout/checkoutduetable')
//     }

//     useEffect(() => {
//         const today = dayjs();
//         const formattedToday = today.format('DD/MM/YYYY');
//         setValue('CheckedOutDt', formattedToday);
//         setSelectedCheckoutDate(formattedToday);
//     }, []);
//     const handleDeleteCharges = async () => {
//         setOpenCheckinConfirm(false);

//         if (!checkoutSettlementData?.ChkOutStlId) {
//             toast.error("No charges to delete");
//             return;
//         }

//         const payload = {
//             "ChkOutStlId": checkoutSettlementData.ChkOutStlId,
//             "ActionBy": parseInt(UserId)
//         }

//         try {
//             const result = await axiosInstance.post('TrnChkOutStl/DeleteTrnChkOutStl', payload)
//             if (result.data.Status === 0) {
//                 toast.success(result.data.Message)
//                 setOtherChargesList([]);
//                 setCheckoutSettlementData(null);
//                 setIsPenaltyCalculated(false);
//                 await fetchOtherCharges();

//             } else {
//                 toast.error(result.data.Message || "Failed to delete charges");
//             }
//         } catch (error) {
//             toast.error('Something went wrong while deleting charges')
//             console.error('Delete error:', error);
//         }
//     }
//     useEffect(() => {
//         setIsSubmitting(false);
//     }, [otherChargesList]);
//     return (
//         <>
//             <Box className="form-container">
//                 <ToastContainer />
//                 <BokingCModal OpenHistoryTableDialog={OpenHistoryTableDialog} handleClose={handleClose} columns={columns} TextField={TextField} handleSearchChange={handleSearchChange} filteredRows={filteredRows} page={page} rowsPerPage={rowsPerPage} handleMobileChange={handleMobileChange} handleBookNoChange={handleBookNoChange} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />
//                 <Grid container spacing={3} className="rasidant_grid" >
//                     <Container maxWidth="lg" spacing={1} justifyContent="center" alignItems="center">
//                         <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
//                             <Typography variant="h5" align="center">
//                                 Check-Out Dues
//                             </Typography>

//                             <Box sx={{ position: 'absolute', right: 0, display: 'flex', gap: 1.5, alignItems: 'center' }}>
//                                 <Tooltip title="Print Report">
//                                     <IconButton
//                                         onClick={handlePrint}
//                                         variant="contained"
//                                         size="small"
//                                         sx={{
//                                             backgroundColor: '#635bff',
//                                             color: 'white',
//                                             borderRadius: '7px', 
//                                             padding:'3px 8px',
//                                             '&:hover': {
//                                                 backgroundColor: '#1565c0',
//                                             }
//                                         }}
//                                     >
//                                         <PrintIcon />
//                                     </IconButton>
//                                 </Tooltip>
//                                 <Tooltip title="Exit" arrow>
//                                     <IconButton
//                                         onClick={handleExitClick}
//                                         variant="contained"
//                                         size="small"
//                                         sx={{
//                                             backgroundColor: '#635bff',
//                                             color: 'white',
//                                             borderRadius: '7px', 
//                                             padding:'3px 8px',
//                                             '&:hover': {
//                                                 backgroundColor: '#1565c0',
//                                             }
//                                         }}
//                                     >
//                                         <CancelPresentationIcon />
//                                     </IconButton>
//                                 </Tooltip>
//                             </Box>

//                             {/* Cancel Checkout Button (Conditional) */}
//                             {TransactionData && TransactionData.length > 0 && TransactionData[0].BookSt === "L" && (
//                                 <Tooltip title="Cancel this checkout" arrow>
//                                     <Box sx={{ position: 'absolute', left: 0 }}>
//                                         <Button
//                                             variant="contained"
//                                             size="small"
//                                             sx={{
//                                                 backgroundColor: "#e01c0dff",
//                                                 whiteSpace: 'nowrap',
//                                                 textOverflow: 'ellipsis',
//                                                 overflow: 'hidden',
//                                                 height: 35,
//                                                 borderRadius: '9px',
//                                                 '&:hover': {
//                                                     boxShadow: '0 5px 8px 2px rgba(255, 82, 82, .4)',
//                                                     background: '#c52838ff'
//                                                 },
//                                             }}
//                                             onClick={handleCheckInClick}
//                                         >
//                                             <CancelIcon sx={{ fontSize: '18px', mr: 1 }} />
//                                             Cancel
//                                         </Button>
//                                     </Box>
//                                 </Tooltip>
//                             )}
//                         </Box>

//                         <Grid container md={12} spacing={0.5}>
//                             <Grid item xs={12} md={2}>
//                                 <FormControl variant="outlined" fullWidth>
//                                     <OutlinedInput
//                                         id="outlined-adornment-weight"
//                                         startAdornment={
//                                             <InputAdornment position="start">
//                                                 <div
//                                                     style={{
//                                                         width: 25,
//                                                         height: 15,
//                                                         backgroundImage: `url(${watch("CountryIcon")})`,
//                                                         backgroundSize: 'cover',
//                                                         backgroundPosition: 'center',
//                                                         borderRadius: '4px',
//                                                         display: 'flex',
//                                                         justifyContent: 'center',
//                                                         alignItems: 'center',
//                                                     }}
//                                                 />
//                                             </InputAdornment>
//                                         }
//                                         aria-describedby="outlined-weight-helper-text"
//                                         placeholder={`Enter Valid  Mobile Number`}
//                                         style={{ width: "100%", height: 40 }}

//                                         value={watch('MobileNo') || ''}
//                                         {...register('MobileNo', { onChange: (e) => handleMobileChange(e, 'A') })}
//                                         inputProps={{
//                                             'aria-label': 'weight',
//                                             style: { height: 40 },
//                                         }}
//                                     />
//                                 </FormControl>
//                             </Grid>
//                             <Grid item xs={12} md={3}>
//                                 <TextField
//                                     id="PropName"
//                                     name="PropName"
//                                     label="Property Name"
//                                     variant="filled"
//                                     fullWidth
//                                     className="custom-textfield"
//                                     value={watch('PropName') || ''}
//                                     {...register('PropName')}
//                                     InputProps={{
//                                         readOnly: true,
//                                     }}
//                                     disabled={true}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} md={3}>
//                                 <TextField
//                                     id="ResidentName"
//                                     name="ResidentName"
//                                     label="First Name"
//                                     variant="filled"
//                                     fullWidth
//                                     className="custom-textfield"
//                                     value={watch('ResidentName') || ''}
//                                     {...register('ResidentName')}
//                                     InputProps={{
//                                         readOnly: true,
//                                     }}
//                                     disabled={true}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={2}>
//                                 <TextField
//                                     id="ChkOutStlNo"
//                                     name="ChkOutStlNo"
//                                     label="Settlement No"
//                                     variant="filled"
//                                     value={checkoutSettlementData?.ChkOutStlNo || ""}
//                                     fullWidth
//                                     className="custom-textfield"
//                                     InputProps={{
//                                         readOnly: true,
//                                     }}
//                                     disabled={true}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} md={2}>
//                                 <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                     <DatePicker
//                                         label={
//                                             <>
//                                                 Settelment Date <span style={{ color: 'red' }}>*</span>
//                                             </>
//                                         }
//                                         value={watch('ChkOutStlDt') ? dayjs(watch('CheckedOutDt'), 'DD/MM/YYYY') : dayjs()}
//                                         onChange={(newValue) => {
//                                             if (newValue) {
//                                                 const formattedDate = newValue.format('DD/MM/YYYY');
//                                                 setValue('CheckedOutDt', formattedDate);
//                                                 setSelectedCheckoutDate(formattedDate);
//                                             } else {
//                                                 const today = dayjs().format('DD/MM/YYYY');
//                                                 setValue('CheckedOutDt', today);
//                                                 setSelectedCheckoutDate(today);
//                                             }
//                                         }}
//                                         minDate={dayjs(watch('CheckinDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])}
//                                         format="DD/MM/YYYY"
//                                         slotProps={{
//                                             textField: {
//                                                 variant: 'filled',
//                                                 fullWidth: true,
//                                                 className: 'custom-textfield',
//                                                 error: !watch('CheckedOutDt'),
//                                                 helperText: !watch('CheckedOutDt') ? "Checkout date is required" : ""
//                                             },
//                                         }}
//                                     />
//                                 </LocalizationProvider>
//                             </Grid>

//                             <Grid item xs={12} md={2}>
//                                 <TextField
//                                     id="BookNo"
//                                     name="BookNo"
//                                     label="Book No"
//                                     variant="filled"
//                                     fullWidth
//                                     className="custom-textfield"
//                                     value={watch('BookNo') || ''}
//                                     {...register('BookNo', { onChange: (e) => handleBookNoChange(e, 'A') })}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={2}>
//                                 <TextField
//                                     id="BookDt"
//                                     name="BookDt"
//                                     label="Book Date"
//                                     variant="filled"
//                                     // type="date"
//                                     fullWidth
//                                     className="custom-textfield"
//                                     value={formatDate(watch('BookDt'))}
//                                     {...register('BookDt')}
//                                     InputProps={{
//                                         readOnly: true,
//                                     }}
//                                     disabled={true}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={2}>
//                                 <TextField
//                                     id="Duration"
//                                     name="Duration"
//                                     label="Duration"
//                                     variant="filled"
//                                     fullWidth
//                                     className="custom-textfield"
//                                     value={watch('Duration') || ''}
//                                     {...register('Duration')}
//                                     InputProps={{
//                                         readOnly: true,
//                                     }}
//                                     disabled={true}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={2}>
//                                 <TextField
//                                     id="CheckinDt"
//                                     name="CheckinDt"
//                                     // type="date"
//                                     label="Checkin Date"
//                                     variant="filled"
//                                     fullWidth
//                                     className="custom-textfield"
//                                     value={formatDate(watch('CheckinDt'))}
//                                     {...register('CheckinDt')}
//                                     InputProps={{
//                                         readOnly: true,
//                                     }}
//                                     disabled={true}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={2}>
//                                 <TextField
//                                     id="BookUpToDt"
//                                     name="BookUpToDt"
//                                     label="Checkout Date"
//                                     // type="date"
//                                     variant="filled"
//                                     fullWidth
//                                     className="custom-textfield"
//                                     value={formatDate(watch('BookUpToDt'))}
//                                     {...register('BookUpToDt')}
//                                     InputProps={{
//                                         readOnly: true,
//                                     }}
//                                     disabled={true}
//                                 />
//                             </Grid>

//                             <Grid item xs={12} md={2} sx={{ display: "flex", justifyContent: { xs: 'flex-end', md: 'flex-start' }, alignItems: 'center' }}>
//                                 <Tooltip title='Get booking details data' arrow>
//                                     <Button
//                                         variant="contained"
//                                         size="medium"
//                                         sx={{
//                                             backgroundColor: "#635bff",
//                                             height: 35,
//                                             whiteSpace: 'nowrap',
//                                             textOverflow: 'ellipsis',
//                                             overflow: 'hidden',
//                                             borderRadius: '9px'
//                                         }}
//                                         onClick={handleClickCheckAva}
//                                     >
//                                         Get Data
//                                     </Button>
//                                 </Tooltip>

//                             </Grid>
//                         </Grid>
//                         <hr></hr>
//                         <Grid container spacing={1}>
//                             <Grid item xs={12} sm={2}>
//                                 <Typography variant="h6" gutterBottom >
//                                     Room Details
//                                 </Typography>
//                             </Grid>
//                             {/* Work Info Column */}
//                             <Grid item xs={12} sm={10}>
//                                 <Grid container spacing={1} >
//                                     <Grid item xs={6} md={2} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
//                                         <TextField
//                                             id="WingName"
//                                             name="WingName"
//                                             label="Wing"
//                                             variant="filled"
//                                             fullWidth
//                                             className="custom-textfield"
//                                             value={watch('WingName') || ''}
//                                             {...register('WingName')}
//                                             InputProps={{
//                                                 readOnly: true,
//                                             }}
//                                             disabled={true}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={6} md={2} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
//                                         <TextField
//                                             id="FloorName"
//                                             name="FloorName"
//                                             label="Floor"
//                                             variant="filled"
//                                             fullWidth
//                                             className="custom-textfield"
//                                             value={watch('FloorName') || ''}
//                                             {...register('FloorName')}
//                                             InputProps={{
//                                                 readOnly: true,
//                                             }}
//                                             disabled={true}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={6} md={2}>
//                                         <TextField
//                                             id="RoomTypeName"
//                                             name="RoomTypeName"
//                                             label="Room Type"
//                                             variant="filled"
//                                             fullWidth
//                                             className="custom-textfield"
//                                             value={watch('RoomTypeName') || ''}
//                                             {...register('RoomTypeName')}
//                                             InputProps={{
//                                                 readOnly: true,
//                                             }}
//                                             disabled={true}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={6} md={2}>
//                                         <TextField
//                                             id="RoombedName"
//                                             name="RoombedName"
//                                             label="Bed No"
//                                             variant="filled"
//                                             fullWidth
//                                             className="custom-textfield"
//                                             value={watch('RoombedName') || ''}
//                                             {...register('RoombedName')}
//                                             InputProps={{
//                                                 readOnly: true,
//                                             }}
//                                             disabled={true}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={6} md={2}>
//                                         <TextField
//                                             id="RoomBedTypeName"
//                                             name="RoomBedTypeName"
//                                             label="Bed Type"
//                                             variant="filled"
//                                             fullWidth
//                                             className="custom-textfield"
//                                             value={watch('RoomBedTypeName') || ''}
//                                             {...register('RoomBedTypeName')}
//                                             InputProps={{
//                                                 readOnly: true,
//                                             }}
//                                             disabled={true}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={6} md={2}>
//                                         <TextField
//                                             id="BedRent"
//                                             name="BedRent"
//                                             label="Standard Rent"
//                                             variant="filled"
//                                             fullWidth
//                                             className="custom-textfield"
//                                             {...register('BedRent')}
//                                             value={watch('BedRent') || ''}
//                                             InputProps={{
//                                                 readOnly: true,
//                                             }}
//                                             disabled={true}
//                                         />
//                                     </Grid>
//                                 </Grid>
//                             </Grid>
//                         </Grid>
//                         <hr></hr>
//                         <Grid container spacing={1} sx={{ mt: 1, display: { xs: 'none', sm: 'none' } }}>
//                             <Grid item xs={12} sm={2}>
//                                 <Typography variant="h6" gutterBottom >
//                                     Outstanding Amount
//                                 </Typography>
//                             </Grid>

//                             {/* Work Info Column */}
//                             <Grid item xs={12} sm={10} >
//                                 <Grid container spacing={1}  >
//                                     <Grid item xs={12} md={4}>
//                                         <TextField
//                                             id="TopupAmt"
//                                             name="TopupAmt"
//                                             label="Outstanding Amount"
//                                             variant="filled"
//                                             fullWidth
//                                             className="custom-textfield"
//                                             {...register('TopupAmt')}
//                                             value={watch('TopupAmt') || ''}
//                                             InputProps={{
//                                                 readOnly: true,
//                                             }}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={12} md={4}>
//                                         <TextField
//                                             id="TAmount"
//                                             name="TAmount"
//                                             label="Transport Service"
//                                             variant="filled"
//                                             fullWidth
//                                             className="custom-textfield"
//                                             {...register('TAmount')}
//                                             value={watch('TAmount') || ''}
//                                             InputProps={{
//                                                 readOnly: true,
//                                             }}
//                                         />
//                                     </Grid>

//                                     <Grid item xs={12} md={4}>
//                                         <TextField
//                                             id="MAmount"
//                                             name="MAmount"
//                                             label="Mess Service"
//                                             variant="filled"
//                                             fullWidth
//                                             className="custom-textfield"
//                                             {...register('MAmount')}
//                                             value={watch('MAmount') || ''}
//                                             InputProps={{
//                                                 readOnly: true,
//                                             }}
//                                         />
//                                     </Grid>
//                                 </Grid>
//                                 {/* </Paper> */}
//                             </Grid>
//                         </Grid>
//                         <Grid container spacing={1} sx={{ display: { xs: '', sm: 'flex' } }}>
//                             <Grid container spacing={1} sx={{ marginLeft: '0px' }} >
//                                 <Grid item xs={12} sm={12} md={6} display="flex" alignItems="center">
//                                     <Typography variant="p" gutterBottom sx={{ mr: 1 }}>
//                                         Booking Status:
//                                     </Typography>
//                                     {TransactionData && TransactionData?.length > 0 ? (
//                                         <Typography
//                                             component="span"
//                                             style={{
//                                                 color: TransactionData[0].BookSt === "C" ? "green" :
//                                                     TransactionData[0].BookSt === "B" ? "blue" :
//                                                         TransactionData[0].BookSt === "O" ? "orange" : "red",
//                                                 fontWeight: "bold",
//                                                 marginLeft: "8px",
//                                                 fontSize: '14px'
//                                             }}
//                                         >
//                                             {TransactionData[0].BookSt === "C"
//                                                 ? "Confirmed"
//                                                 : TransactionData[0].BookSt === "B"
//                                                     ? "Booked"
//                                                     : TransactionData[0].BookSt === "O"
//                                                         ? "CheckedIn"
//                                                         : TransactionData[0].BookSt === "L"
//                                                             ? "CheckOut"
//                                                             : TransactionData[0].BookSt === "X"
//                                                                 ? "Cancelled"
//                                                                 : "Unknown"}
//                                         </Typography>
//                                     ) : (
//                                         <Typography variant="body1" sx={{ color: 'gray', fontWeight: 'bold' }}>
//                                             Not Found
//                                         </Typography>
//                                     )}
//                                 </Grid>
//                             </Grid>
//                             <Grid container spacing={1.5} sx={{ marginLeft: '0px', alignItems: 'center' }}>
//                                 <Grid item xs={6} md={2.3} lg={2.3} className="form_field">
//                                     <Autocomplete
//                                         options={OthChrgDrp}
//                                         id="OthChrgId-autocomplete"
//                                         value={selectedCharge}
//                                         onChange={handleChargeChange}
//                                         getOptionLabel={(option) => option?.Name || ""}
//                                         isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
//                                         disableClearable
//                                         popupIcon={null}
//                                         clearIcon={null}
//                                         renderInput={(params) => (
//                                             <TextField
//                                                 {...params}
//                                                 variant="filled"
//                                                 label="Other Charges"
//                                                 placeholder="Select charge"
//                                                 fullWidth
//                                                 className="custom-textfield"
//                                                 InputProps={{
//                                                     ...params.InputProps,
//                                                     endAdornment: (
//                                                         <>
//                                                             <Tooltip title="Add New" arrow>
//                                                                 <InputAdornment position="end">
//                                                                     <IconButton
//                                                                         onClick={openOth}
//                                                                         edge="end"
//                                                                         size="small"
//                                                                         sx={{
//                                                                             color: '#635bff',
//                                                                             marginRight: '-35px',
//                                                                             '&:hover': {
//                                                                                 backgroundColor: 'rgba(99, 91, 255, 0.08)',
//                                                                             }
//                                                                         }}
//                                                                     >
//                                                                         <AddIcon />
//                                                                     </IconButton>
//                                                                 </InputAdornment>
//                                                             </Tooltip>
//                                                             {params.InputProps.endAdornment}
//                                                         </>
//                                                     ),
//                                                     disableUnderline: true,
//                                                 }}
//                                                 sx={{
//                                                     '& .MuiInputLabel-root': {
//                                                         fontSize: '0.875rem',
//                                                         transform: 'translate(12px, 10px) scale(1)',
//                                                         '&.Mui-focused': {
//                                                             transform: 'translate(12px, 6px) scale(0.75)',
//                                                             color: '#673ab7'
//                                                         },
//                                                         '&.MuiFormLabel-filled': {
//                                                             transform: 'translate(12px, 6px) scale(0.75)'
//                                                         }
//                                                     },
//                                                     '& .MuiFilledInput-root': {
//                                                         height: '38px',
//                                                         minHeight: '38px',
//                                                         backgroundColor: "transparent",
//                                                         border: "1px solid #e0e0e0",
//                                                         borderRadius: "6px",
//                                                         '&:hover': {
//                                                             borderColor: "#b3b3b3",
//                                                         },
//                                                         '& .MuiInputBase-input': {
//                                                             padding: '8px 12px 8px',
//                                                             fontSize: '0.875rem'
//                                                         }
//                                                     },
//                                                     '& .MuiFilledInput-root.Mui-focused': {
//                                                         border: "1px solid #673ab7",
//                                                         boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
//                                                     },
//                                                 }}
//                                             />
//                                         )}
//                                         renderOption={(props, option) => (
//                                             <li {...props} key={option.Id}>
//                                                 {option.Name}
//                                             </li>
//                                         )}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={6} md={1.4} lg={1.4} className="form_field">
//                                     <TextField
//                                         label="Amount"
//                                         type="number"
//                                         variant="filled"
//                                         className="custom-textfield"
//                                         fullWidth
//                                         value={amount}
//                                         onChange={(e) => setAmount(e.target.value)}
//                                         sx={{
//                                             '& .MuiInputLabel-root': {
//                                                 fontSize: '0.875rem',
//                                                 transform: 'translate(12px, 10px) scale(1)',
//                                                 '&.Mui-focused': {
//                                                     transform: 'translate(12px, 6px) scale(0.75)',
//                                                     color: '#673ab7'
//                                                 },
//                                                 '&.MuiFormLabel-filled': {
//                                                     transform: 'translate(12px, 6px) scale(0.75)'
//                                                 }
//                                             },
//                                             '& .MuiFilledInput-root': {
//                                                 height: '38px',
//                                                 minHeight: '38px',
//                                                 backgroundColor: "transparent",
//                                                 border: "1px solid #e0e0e0",
//                                                 borderRadius: "6px",
//                                                 '&:hover': {
//                                                     borderColor: "#b3b3b3",
//                                                 },
//                                                 '& .MuiInputBase-input': {
//                                                     padding: '8px 12px 8px',
//                                                     fontSize: '0.875rem'
//                                                 }
//                                             },
//                                             '& .MuiFilledInput-root.Mui-focused': {
//                                                 border: "1px solid #673ab7",
//                                                 boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
//                                             },
//                                         }}
//                                     />
//                                 </Grid>

//                                 <Grid item xs={6} md={1.4} lg={1.4} className="form_field">
//                                     <TextField
//                                         label="Discount"
//                                         type="number"
//                                         variant="filled"
//                                         className="custom-textfield"
//                                         fullWidth
//                                         value={discount}
//                                         onChange={(e) => setDiscount(e.target.value)}
//                                         sx={{
//                                             '& .MuiInputLabel-root': {
//                                                 fontSize: '0.875rem',
//                                                 transform: 'translate(12px, 10px) scale(1)',
//                                                 '&.Mui-focused': {
//                                                     transform: 'translate(12px, 6px) scale(0.75)',
//                                                     color: '#673ab7'
//                                                 },
//                                                 '&.MuiFormLabel-filled': {
//                                                     transform: 'translate(12px, 6px) scale(0.75)'
//                                                 }
//                                             },
//                                             '& .MuiFilledInput-root': {
//                                                 height: '38px',
//                                                 minHeight: '38px',
//                                                 backgroundColor: "transparent",
//                                                 border: "1px solid #e0e0e0",
//                                                 borderRadius: "6px",
//                                                 '&:hover': {
//                                                     borderColor: "#b3b3b3",
//                                                 },
//                                                 '& .MuiInputBase-input': {
//                                                     padding: '8px 12px 8px',
//                                                     fontSize: '0.875rem'
//                                                 }
//                                             },
//                                             '& .MuiFilledInput-root.Mui-focused': {
//                                                 border: "1px solid #673ab7",
//                                                 boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
//                                             },
//                                         }}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={6} md={1.4} lg={1.4} className="form_field">
//                                     <TextField
//                                         label="Net Amount"
//                                         type="number"
//                                         variant="filled"
//                                         fullWidth
//                                         className="custom-textfield"
//                                         value={totalAmount}
//                                         onChange={(e) => setTotalAmount(e.target.value)}
//                                         InputProps={{
//                                             readOnly: true,
//                                         }}
//                                         sx={{
//                                             '& .MuiInputLabel-root': {
//                                                 fontSize: '0.875rem',
//                                                 transform: 'translate(12px, 10px) scale(1)',
//                                                 '&.Mui-focused': {
//                                                     transform: 'translate(12px, 6px) scale(0.75)',
//                                                     color: '#673ab7'
//                                                 },
//                                                 '&.MuiFormLabel-filled': {
//                                                     transform: 'translate(12px, 6px) scale(0.75)'
//                                                 }
//                                             },
//                                             '& .MuiFilledInput-root': {
//                                                 height: '38px',
//                                                 minHeight: '38px',
//                                                 backgroundColor: "#f8f9fa",
//                                                 border: "1px solid #e0e0e0",
//                                                 borderRadius: "6px",
//                                                 '& .MuiInputBase-input': {
//                                                     padding: '8px 12px 8px',
//                                                     fontSize: '0.875rem',
//                                                     color: '#666'
//                                                 }
//                                             },
//                                             '& .MuiFilledInput-root.Mui-focused': {
//                                                 border: "1px solid #673ab7",
//                                                 boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
//                                             },
//                                         }}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={6} md={2.5} lg={2.5} className="form_field">
//                                     <TextField
//                                         label="Remark"
//                                         type="text"
//                                         variant="filled"
//                                         className="custom-textfield"
//                                         fullWidth
//                                         value={remark}
//                                         onChange={(e) => setRemark(e.target.value)}
//                                         sx={{
//                                             '& .MuiInputLabel-root': {
//                                                 fontSize: '0.875rem',
//                                                 transform: 'translate(12px, 10px) scale(1)',
//                                                 '&.Mui-focused': {
//                                                     transform: 'translate(12px, 6px) scale(0.75)',
//                                                     color: '#673ab7'
//                                                 },
//                                                 '&.MuiFormLabel-filled': {
//                                                     transform: 'translate(12px, 6px) scale(0.75)'
//                                                 }
//                                             },
//                                             '& .MuiFilledInput-root': {
//                                                 height: '38px',
//                                                 minHeight: '38px',
//                                                 backgroundColor: "transparent",
//                                                 border: "1px solid #e0e0e0",
//                                                 borderRadius: "6px",
//                                                 '&:hover': {
//                                                     borderColor: "#b3b3b3",
//                                                 },
//                                                 '& .MuiInputBase-input': {
//                                                     padding: '8px 12px 8px',
//                                                     fontSize: '0.875rem'
//                                                 }
//                                             },
//                                             '& .MuiFilledInput-root.Mui-focused': {
//                                                 border: "1px solid #673ab7",
//                                                 boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
//                                             },
//                                         }}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12} md={3} lg={3} className="form_field">
//                                     <Box display="flex" flexDirection="row" gap={1}>
//                                         <Button
//                                             variant="contained"
//                                             color="primary"
//                                             onClick={handleAddCharge}
//                                             disabled={!isButtondisable}
//                                             sx={{
//                                                 height: '38px',
//                                                 minHeight: '38px',
//                                                 borderRadius: '6px',
//                                                 textTransform: 'none',
//                                                 fontWeight: 600,
//                                                 fontSize: '0.875rem',
//                                                 boxShadow: 'none',
//                                                 '&:hover': {
//                                                     boxShadow: '0 2px 6px rgba(103, 58, 183, 0.3)',
//                                                 }
//                                             }}
//                                         >
//                                             Add Charge
//                                         </Button>
//                                         <Button
//                                             variant="contained"
//                                             onClick={handleCalculateCharges}
//                                             disabled={!isButtondisable || isPenaltyCalculated }
//                                             sx={{
//                                                 height: '38px',
//                                                 minHeight: '38px',
//                                                 borderRadius: '6px',
//                                                 textTransform: 'none',
//                                                 fontWeight: 600,
//                                                 fontSize: '0.875rem',
//                                                 backgroundColor: '#ff6347',
//                                                 '&:hover': {
//                                                     backgroundColor: '#ff4500',
//                                                     boxShadow: '0 2px 6px rgba(255, 69, 0, 0.3)',
//                                                 },
//                                                 '&.Mui-disabled': {
//                                                     backgroundColor: 'rgba(0, 0, 0, 0.12)',
//                                                     color: 'rgba(0, 0, 0, 0.26)',
//                                                 }
//                                             }}
//                                         >
//                                             Calc Dues
//                                         </Button>
//                                         <IconButton
//                                             size="small"
//                                             color="error"
//                                             onClick={() => setOpenCheckinConfirm(true)}
//                                             disabled={otherChargesList.length === 0}
//                                             sx={{
//                                                 height: '37px',
//                                                 minHeight: '37px',
//                                                 borderRadius: '6px',
//                                                 textTransform: 'none',
//                                                 fontWeight: 600,
//                                                 fontSize: '1rem',
//                                                 backgroundColor: 'red',
//                                                 '&:hover': {
//                                                     backgroundColor: '#F5310C',
//                                                 },
//                                             }}
//                                         >
//                                             <DeleteIcon sx={{
//                                                 fontSize: { xs: '16px', sm: '18px' },
//                                                 color: '#f5ededff'
//                                             }} />
//                                         </IconButton>
//                                     </Box>
//                                 </Grid>
//                             </Grid>
//                         </Grid>
//                         {otherChargesList?.length > 0 && (
//                             <Grid container sx={{ mt: 1 }}>
//                                 <Grid item xs={12}>
//                                     <Typography
//                                         variant="h6"
//                                         gutterBottom
//                                         sx={{
//                                             mb: 1,
//                                             fontSize: { xs: '0.85rem', sm: '0.95rem' },
//                                             fontWeight: 'bold',
//                                             color: '#1976d2',
//                                             background: 'lightgray',
//                                             padding: { xs: '6px 8px', sm: '8px 12px' },
//                                             borderRadius: '4px',
//                                             borderLeft: '4px solid #1976d2'
//                                         }}
//                                     >
//                                         💰 Added Charges & Refunds
//                                     </Typography>
//                                     <TableContainer
//                                         component={Paper}
//                                         sx={{
//                                             maxHeight: 170,
//                                             boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                                             border: '1px solid #e0e0e0',
//                                             borderRadius: '8px',
//                                             background: 'linear(145deg, #ffffff, #fafafa)',
//                                             overflowX: 'auto'
//                                         }}
//                                     >
//                                         <Table
//                                             stickyHeader
//                                             size="small"
//                                             sx={{
//                                                 minWidth: 650,
//                                                 '& .MuiTableCell-root': {
//                                                     padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                     border: '1px solid #e0e0e0',
//                                                     lineHeight: '1.2'
//                                                 },
//                                                 '& .MuiTableHead-root .MuiTableCell-root': {
//                                                     background: 'linear(45deg, #667eea 0%, #764ba2 100%)',
//                                                     color: 'white',
//                                                     fontWeight: 'bold',
//                                                     fontSize: { xs: '0.7rem', sm: '0.75rem' },
//                                                     padding: { xs: '4px 6px', sm: '6px 8px' },
//                                                     borderBottom: '2px solid #5a6fd8',
//                                                     whiteSpace: 'nowrap'
//                                                 },
//                                                 '& .MuiTableBody-root .MuiTableCell-root': {
//                                                     fontSize: { xs: '0.7rem', sm: '0.75rem' },
//                                                     padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                     whiteSpace: 'nowrap'
//                                                 },
//                                                 '& .MuiTableRow-root': {
//                                                     height: { xs: '28px', sm: '32px' }
//                                                 }
//                                             }}
//                                         >
//                                             <TableHead>
//                                                 <TableRow>
//                                                     <TableCell sx={{
//                                                         width: { xs: '35%', sm: '35%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }}>Charge/Refund Name</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '15%', sm: '15%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }} align="right">Amount</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '15%', sm: '15%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }} align="right">Discount</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '20%', sm: '20%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }} align="right">Net Amount</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '15%', sm: '15%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }} align="center">Action</TableCell>
//                                                 </TableRow>
//                                             </TableHead>
//                                             <TableBody>
//                                                 {otherChargesList
//                                                     .filter(charge => !charge.isNegative && charge.netAmount >= 0)
//                                                     .map((charge) => (
//                                                         <TableRow
//                                                             key={charge.ChkOutStlDtlId || charge.id}
//                                                             sx={{
//                                                                 height: { xs: '28px', sm: '32px' },
//                                                                 '&:nth-of-type(odd)': {
//                                                                     backgroundColor: '#f8fbff'
//                                                                 },
//                                                                 '&:nth-of-type(even)': {
//                                                                     backgroundColor: '#ffffff'
//                                                                 },
//                                                                 '&:hover': {
//                                                                     backgroundColor: '#f0f7ff'
//                                                                 }
//                                                             }}
//                                                         >
//                                                             <TableCell sx={{
//                                                                 padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                                 fontWeight: 'bold',
//                                                                 color: '#1565c0',
//                                                                 fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                             }}>
//                                                                 {charge.ChrgName || charge.chargeName}
//                                                             </TableCell>
//                                                             <TableCell sx={{
//                                                                 padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                                 fontWeight: 'bold',
//                                                                 color: '#2e7d32',
//                                                                 fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                             }} align="right">
//                                                                 ₹{charge.ChrgAmt || charge.amount}
//                                                             </TableCell>
//                                                             <TableCell sx={{
//                                                                 padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                                 fontWeight: 'bold',
//                                                                 color: '#ff9800',
//                                                                 fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                             }} align="right">
//                                                                 ₹{charge.DiscAmt || charge.discount}
//                                                             </TableCell>
//                                                             <TableCell sx={{
//                                                                 padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                                 fontWeight: 'bold',
//                                                                 color: '#1976d2',
//                                                                 fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                             }} align="right">
//                                                                 ₹{Math.abs(charge.NetAmt || charge.netAmount)}
//                                                             </TableCell>
//                                                             <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
//                                                                 <IconButton
//                                                                     size="small"
//                                                                     color="error"
//                                                                     onClick={() => handleDeleteCharge(charge.id)}
//                                                                     sx={{
//                                                                         padding: '2px',
//                                                                         '&:hover': {
//                                                                             backgroundColor: 'rgba(211, 47, 47, 0.1)',
//                                                                             transform: 'scale(1.1)',
//                                                                             transition: 'transform 0.2s ease'
//                                                                         },
//                                                                         height: { xs: '20px', sm: '22px' },
//                                                                         width: { xs: '20px', sm: '22px' }
//                                                                     }}
//                                                                 >
//                                                                     <DeleteIcon sx={{
//                                                                         fontSize: { xs: '14px', sm: '16px' },
//                                                                         color: '#d32f2f'
//                                                                     }} />
//                                                                 </IconButton>
//                                                             </TableCell>
//                                                         </TableRow>
//                                                     ))
//                                                 }

//                                                 {otherChargesList
//                                                     .filter(charge => charge.isNegative || charge.netAmount < 0)
//                                                     .map((charge) => (
//                                                         <TableRow
//                                                             key={charge.ChkOutStlDtlId || charge.id}
//                                                             sx={{
//                                                                 height: { xs: '28px', sm: '32px' },
//                                                                 backgroundColor: '#fff8f8',
//                                                                 '&:hover': {
//                                                                     backgroundColor: '#ffeaea'
//                                                                 }
//                                                             }}
//                                                         >
//                                                             <TableCell sx={{
//                                                                 padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                                 fontWeight: 'bold',
//                                                                 color: '#d32f2f',
//                                                                 fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                             }}>
//                                                                 {charge.ChrgName || charge.chargeName} (Refund)
//                                                             </TableCell>
//                                                             <TableCell sx={{
//                                                                 padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                                 fontWeight: 'bold',
//                                                                 color: '#d32f2f',
//                                                                 fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                             }} align="right">
//                                                                 ₹{charge.ChrgAmt || charge.amount}
//                                                             </TableCell>
//                                                             <TableCell sx={{
//                                                                 padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                                 fontWeight: 'bold',
//                                                                 color: '#ff9800',
//                                                                 fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                             }} align="right">
//                                                                 ₹{charge.DiscAmt || charge.discount}
//                                                             </TableCell>
//                                                             <TableCell sx={{
//                                                                 padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                                 fontWeight: 'bold',
//                                                                 color: '#d32f2f',
//                                                                 fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                             }} align="right">
//                                                                 - ₹{Math.abs(charge.NetAmt || charge.netAmount)}
//                                                             </TableCell>
//                                                             <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
//                                                                 <IconButton
//                                                                     size="small"
//                                                                     color="error"
//                                                                     onClick={() => handleDeleteCharge(charge.id)}
//                                                                     sx={{
//                                                                         padding: '2px',
//                                                                         '&:hover': {
//                                                                             backgroundColor: 'rgba(211, 47, 47, 0.1)',
//                                                                             transform: 'scale(1.1)',
//                                                                             transition: 'transform 0.2s ease'
//                                                                         },
//                                                                         height: { xs: '20px', sm: '22px' },
//                                                                         width: { xs: '20px', sm: '22px' }
//                                                                     }}
//                                                                 >
//                                                                     <DeleteIcon sx={{
//                                                                         fontSize: { xs: '14px', sm: '16px' },
//                                                                         color: '#d32f2f'
//                                                                     }} />
//                                                                 </IconButton>
//                                                             </TableCell>
//                                                         </TableRow>
//                                                     ))
//                                                 }

//                                                 {/* Total Row */}
//                                                 <TableRow sx={{
//                                                     backgroundColor: '#f8f9fa',
//                                                     height: { xs: '28px', sm: '32px' },
//                                                     '&:hover': {
//                                                         backgroundColor: totalChargesAmount < 0 ? '#ffebee' : '#e8f5e9'
//                                                     }
//                                                 }}>
//                                                     <TableCell
//                                                         colSpan={3}
//                                                         align="right"
//                                                         sx={{
//                                                             fontWeight: 'bold',
//                                                             fontSize: { xs: '0.7rem', sm: '0.75rem' },
//                                                             padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                             color: totalChargesAmount < 0 ? '#d32f2f' : '#2e7d32'
//                                                         }}
//                                                     >
//                                                         Net Total:
//                                                     </TableCell>
//                                                     <TableCell
//                                                         align="right"
//                                                         sx={{
//                                                             fontWeight: 'bold',
//                                                             fontSize: { xs: '0.7rem', sm: '0.75rem' },
//                                                             padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                             color: totalChargesAmount < 0 ? '#d32f2f' : '#2e7d32',
//                                                             borderLeft: `2px solid ${totalChargesAmount < 0 ? '#f44336' : '#4caf50'}`
//                                                         }}
//                                                     >
//                                                         {totalChargesAmount < 0 ? '- ' : ''}₹{Math.abs(totalChargesAmount)}
//                                                     </TableCell>
//                                                     <TableCell sx={{
//                                                         padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                         background: totalChargesAmount < 0 ?
//                                                             'linear(45deg, #f44336, #ef5350)' :
//                                                             'linear(45deg, #4caf50, #66bb6a)'
//                                                     }}></TableCell>
//                                                 </TableRow>
//                                             </TableBody>
//                                         </Table>
//                                     </TableContainer>
//                                 </Grid>
//                                 <Grid item xs={12} sx={{
//                                     display: 'flex',
//                                     justifyContent: 'flex-end',
//                                     mt: 1,
//                                     gap: 1
//                                 }}>
//                                     <Typography
//                                         sx={{
//                                             fontWeight: 'bold',
//                                             color: totalChargesAmount < 0 ? '#d32f2f' : '#2e7d32',
//                                             fontSize: '1rem'
//                                         }}
//                                     >
//                                         {totalChargesAmount < 0 ? 'TOTAL REFUND :' : 'TOTAL PAYABLE :'}
//                                     </Typography>
//                                     <Typography
//                                         sx={{
//                                             fontWeight: 'bold',
//                                             color: totalChargesAmount < 0 ? '#d32f2f' : '#2e7d32',
//                                             fontSize: '1rem',
//                                             minWidth: '80px'
//                                         }}
//                                     >
//                                         {totalChargesAmount < 0 ? '- ' : ''}₹{Math.abs(totalChargesAmount)}
//                                     </Typography>
//                                     {totalChargesAmount > 0 ? (
//                                         <Button
//                                             variant="contained"
//                                             color="primary"
//                                             onClick={handleCalculate}
//                                             size='small'
//                                         >
//                                             Calc Settlement advice
//                                         </Button>
//                                     ) : ""}

//                                     <Button
//                                         variant="contained"
//                                         color="primary"
//                                         onClick={handleSubmitdata}
//                                         size='small'
//                                         disabled={isSubmitting || otherChargesList.length === 0}
//                                         sx={{
//                                             position: 'relative',
//                                             '&:disabled': {
//                                                 backgroundColor: '#cccccc',
//                                                 color: '#666666'
//                                             }
//                                         }}
//                                     >
//                                         {isSubmitting ? (
//                                             <>
//                                                 <CircularProgress
//                                                     size={16}
//                                                     sx={{
//                                                         color: 'white',
//                                                         marginRight: 1
//                                                     }}
//                                                 />
//                                                 Submitting...
//                                             </>
//                                         ) : (
//                                             'Submit'
//                                         )}
//                                     </Button>
//                                 </Grid>
//                             </Grid>
//                         )}
//                         {showPayAdvice && payAdvice.length > 0 && (
//                             <Grid container sx={{ mt: 1 }}>
//                                 <Grid item xs={12}>
//                                     <Typography
//                                         variant="h6"
//                                         gutterBottom
//                                         sx={{
//                                             mb: 1,
//                                             fontSize: { xs: '0.85rem', sm: '0.95rem' },
//                                             fontWeight: 'bold',
//                                             color: '#1976d2',
//                                             background: 'lightgray',
//                                             padding: { xs: '6px 8px', sm: '8px 12px' },
//                                             borderRadius: '4px',
//                                             borderLeft: '4px solid #1976d2'
//                                         }}
//                                     >
//                                         💰 Payment Advice Details
//                                     </Typography>
//                                     <TableContainer
//                                         component={Paper}
//                                         sx={{
//                                             maxHeight: 200,
//                                             boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                                             border: '1px solid #e0e0e0',
//                                             borderRadius: '8px',
//                                             background: 'linear(145deg, #ffffff, #fafafa)',
//                                             overflowX: 'auto'
//                                         }}
//                                     >
//                                         <Table
//                                             stickyHeader
//                                             size="small"
//                                             sx={{
//                                                 minWidth: 650,
//                                                 '& .MuiTableCell-root': {
//                                                     padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                     border: '1px solid #e0e0e0',
//                                                     lineHeight: '1.2'
//                                                 },
//                                                 '& .MuiTableHead-root .MuiTableCell-root': {
//                                                     background: 'linear(45deg, #667eea 0%, #764ba2 100%)',
//                                                     color: 'white',
//                                                     fontWeight: 'bold',
//                                                     fontSize: { xs: '0.7rem', sm: '0.75rem' },
//                                                     padding: { xs: '4px 6px', sm: '6px 8px' },
//                                                     borderBottom: '2px solid #5a6fd8',
//                                                     whiteSpace: 'nowrap'
//                                                 },
//                                                 '& .MuiTableBody-root .MuiTableCell-root': {
//                                                     fontSize: { xs: '0.7rem', sm: '0.75rem' },
//                                                     padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                     whiteSpace: 'nowrap'
//                                                 },
//                                                 '& .MuiTableRow-root': {
//                                                     height: { xs: '28px', sm: '32px' },
//                                                     cursor: 'pointer'
//                                                 }
//                                             }}
//                                         >
//                                             <TableHead>
//                                                 <TableRow>
//                                                     <TableCell sx={{
//                                                         width: { xs: '12%', sm: '10%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }}>AdvNo</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '10%', sm: '8%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }}>AdvDt</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '12%', sm: '10%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }}>AdviceFor</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '10%', sm: '8%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }} align="right">AdvAmt</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '10%', sm: '8%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }} align="right">RcdAmt</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '10%', sm: '8%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }} align="right">Balance</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '10%', sm: '8%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }} align="center">DueDays</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '10%', sm: '8%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }}>RecDt</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '14%', sm: '12%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }}>Remark</TableCell>
//                                                     <TableCell sx={{
//                                                         width: { xs: '22%', sm: '20%' },
//                                                         background: '#d7dbd1ff !important',
//                                                         color: 'black !important'
//                                                     }} align="center">Action</TableCell>
//                                                 </TableRow>
//                                             </TableHead>
//                                             <TableBody>
//                                                 {payAdvice?.map((item, index) => (
//                                                     <TableRow
//                                                         key={index}
//                                                         sx={{
//                                                             height: { xs: '25px', sm: '28px' },
//                                                             '&:nth-of-type(odd)': {
//                                                                 backgroundColor: '#f8fbff'
//                                                             },
//                                                             '&:nth-of-type(even)': {
//                                                                 backgroundColor: '#ffffff'
//                                                             },
//                                                             '&:hover': {
//                                                                 backgroundColor: '#f0f7ff'
//                                                             }
//                                                         }}
//                                                         onDoubleClick={() => {
//                                                             const url = `/advicegeneratetable?PytAdvId=${item.PytAdvId}`;
//                                                             window.open(url, '_blank');
//                                                         }}
//                                                     >
//                                                         <TableCell sx={{
//                                                             padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                             fontWeight: 'bold',
//                                                             color: '#1565c0',
//                                                             fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                         }}>
//                                                             {item?.PytAdvNo}
//                                                         </TableCell>
//                                                         <TableCell sx={{
//                                                             padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                             color: '#666',
//                                                             fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                         }}>
//                                                             {moment(item?.PytAdvDt).format("DD-MM-YYYY")}
//                                                         </TableCell>
//                                                         <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }}>
//                                                             <Chip
//                                                                 label={
//                                                                     item?.PytAdvFor === "D" ? "Deposit" :
//                                                                         item?.PytAdvFor === "R" ? "Rent" :
//                                                                             item?.PytAdvFor === "O" ? "Other" :
//                                                                                 item?.PytAdvFor === "T" ? "TopUp" : ""
//                                                                 }
//                                                                 size="small"
//                                                                 sx={{
//                                                                     fontSize: { xs: '0.6rem', sm: '0.65rem' },
//                                                                     height: { xs: '16px', sm: '18px' },
//                                                                     fontWeight: 'bold',
//                                                                     backgroundColor:
//                                                                         item?.PytAdvFor === "D" ? '#e8f5e9' :
//                                                                             item?.PytAdvFor === "R" ? '#fff3e0' :
//                                                                                 item?.PytAdvFor === "O" ? '#f3e5f5' :
//                                                                                     '#e1f5fe',
//                                                                     color:
//                                                                         item?.PytAdvFor === "D" ? '#2e7d32' :
//                                                                             item?.PytAdvFor === "R" ? '#ef6c00' :
//                                                                                 item?.PytAdvFor === "O" ? '#7b1fa2' :
//                                                                                     '#0277bd'
//                                                                 }}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell sx={{
//                                                             padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                             fontWeight: 'bold',
//                                                             color: '#2e7d32',
//                                                             fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                         }} align="right">
//                                                             ₹{item?.Amount}
//                                                         </TableCell>
//                                                         <TableCell sx={{
//                                                             padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                             fontWeight: 'bold',
//                                                             color: '#1976d2',
//                                                             fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                         }} align="right">
//                                                             ₹{item?.RcdAmt || '0'}
//                                                         </TableCell>
//                                                         <TableCell sx={{
//                                                             padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                             fontWeight: 'bold',
//                                                             color: item?.BalAmount > 0 ? '#d32f2f' : '#2e7d32',
//                                                             fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                         }} align="right">
//                                                             ₹{item?.BalAmount}
//                                                         </TableCell>
//                                                         <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
//                                                             <Chip
//                                                                 label={item?.DueDays}
//                                                                 size="small"
//                                                                 sx={{
//                                                                     fontSize: { xs: '0.6rem', sm: '0.65rem' },
//                                                                     height: { xs: '16px', sm: '18px' },
//                                                                     fontWeight: 'bold',
//                                                                     color: 'white',
//                                                                     backgroundColor:
//                                                                         item?.DueDays === 0 ? '#4caf50' :
//                                                                             item?.DueDays <= 7 ? '#ff9800' :
//                                                                                 item?.DueDays <= 30 ? '#f44336' :
//                                                                                     '#d32f2f'
//                                                                 }}
//                                                             />
//                                                         </TableCell>
//                                                         <TableCell sx={{
//                                                             padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                             color: '#666',
//                                                             fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                         }}>
//                                                             {item?.RecDt ? moment(item.RecDt).format("DD-MM-YYYY") : "-"}
//                                                         </TableCell>
//                                                         <TableCell sx={{
//                                                             padding: { xs: '2px 4px', sm: '4px 6px' },
//                                                             color: '#666',
//                                                             fontSize: { xs: '0.7rem', sm: '0.75rem' }
//                                                         }}>
//                                                             {item?.Remark || "-"}
//                                                         </TableCell>
//                                                         <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
//                                                             {item?.PaymentSt && (
//                                                                 <Chip
//                                                                     label={item.PaymentSt}
//                                                                     size="small"
//                                                                     sx={{
//                                                                         fontWeight: 'bold',
//                                                                         color: 'white',
//                                                                         backgroundColor:
//                                                                             item.PaymentSt.toLowerCase() === 'paid' ? '#4CAF50' :
//                                                                                 item.PaymentSt.toLowerCase() === 'partial' ? '#FF9800' :
//                                                                                     '#F44336',
//                                                                         marginRight: item.PaymentSt.toLowerCase() !== 'paid' ? '4px' : 0,
//                                                                         fontSize: { xs: '0.6rem', sm: '0.65rem' },
//                                                                         height: { xs: '18px', sm: '20px' },
//                                                                         boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
//                                                                     }}
//                                                                 />
//                                                             )}
//                                                             {item?.PaymentSt?.toLowerCase() !== 'paid' && (
//                                                                 <Box sx={{
//                                                                     display: 'inline-flex',
//                                                                     gap: 0.5,
//                                                                     ml: 0.5,
//                                                                     flexWrap: { xs: 'wrap', sm: 'nowrap' }
//                                                                 }}>
//                                                                     <Button
//                                                                         variant="contained"
//                                                                         size="small"
//                                                                         color="primary"
//                                                                         onClick={() => handleSendPaymentLink(item)}
//                                                                         sx={{
//                                                                             padding: { xs: '1px 6px', sm: '2px 8px' },
//                                                                             minWidth: 'auto',
//                                                                             fontSize: { xs: '0.55rem', sm: '0.6rem' },
//                                                                             height: { xs: '20px', sm: '22px' },
//                                                                             background: 'linear(45deg, #2196F3, #21CBF3)',
//                                                                             boxShadow: '0 1px 3px rgba(33, 150, 243, 0.3)',
//                                                                             '&:hover': {
//                                                                                 background: 'linear(45deg, #1976D2, #00B0FF)',
//                                                                                 boxShadow: '0 2px 5px rgba(33, 150, 243, 0.4)'
//                                                                             }
//                                                                         }}
//                                                                     >
//                                                                         {loadingPaymentLinks[item.PytAdvId] ? (
//                                                                             <CircularProgress size={10} sx={{ color: 'white' }} />
//                                                                         ) : (
//                                                                             '💳 Pay'
//                                                                         )}
//                                                                     </Button>

//                                                                     <Tooltip title="Refresh Data" arrow>
//                                                                         <IconButton
//                                                                             size="small"
//                                                                             onClick={() => fetchPayAdvice(BookId)}
//                                                                             sx={{
//                                                                                 padding: '2px',
//                                                                                 '&:hover': {
//                                                                                     backgroundColor: 'rgba(255, 152, 0, 0.1)',
//                                                                                     transform: 'rotate(90deg)',
//                                                                                     transition: 'transform 0.3s ease'
//                                                                                 },
//                                                                                 height: { xs: '20px', sm: '22px' },
//                                                                                 width: { xs: '20px', sm: '22px' }
//                                                                             }}
//                                                                         >
//                                                                             <RefreshIcon sx={{
//                                                                                 fontSize: { xs: '12px', sm: '14px' },
//                                                                                 color: '#FF9800',
//                                                                                 fontWeight: 'bold'
//                                                                             }} />
//                                                                         </IconButton>
//                                                                     </Tooltip>
//                                                                 </Box>
//                                                             )}
//                                                         </TableCell>
//                                                     </TableRow>
//                                                 ))}
//                                             </TableBody>
//                                         </Table>
//                                     </TableContainer>
//                                 </Grid>
//                             </Grid>
//                         )}

//                         {showPayAdvice && pendingAdvice.length > 0 && (
//                                                 <UnbuildAdvice
//                                                     pendingAdvice={pendingAdvice}
//                                                     loadingPaymentLinks={loadingPaymentLinks}
//                                                     fetchPendingAdvice={fetchPendingAdvice}
//                                                     BookId={BookId}
//                                                     handleSendPaymentLink={handleSendPaymentLink}
//                                                 />
//                                             )}
//                     </Container>
//                     <div style={{ display: 'none' }}>
//                         {<PrintCharges
//                             contentRef={contentRef}
//                             DataObj={watch()}
//                             otherChargesList={otherChargesList}
//                             totalChargesAmount={totalChargesAmount}
//                             checkoutSettlementData={checkoutSettlementData}
//                         />
//                         }
//                     </div>
//                     <ConfirmationDialog
//                         open={openCheckoutConfirm}
//                         onClose={() => setOpenCheckoutConfirm(false)}
//                         onConfirm={handleCheckoutConfirm}
//                         title="Confirm Checkout"
//                         message="Are you sure you want to checkout this booking?"
//                     />
//                     <ConfirmationDialog
//                         open={openCheckinConfirm}
//                         onClose={() => setOpenCheckinConfirm(false)}
//                         onConfirm={handleDeleteCharges}
//                         title="Delete Charges"
//                         message="Are you sure you want to delete all charges ?"
//                     />

//                 </Grid>
//             </Box >
//         </>
//     )
// }

// export default Checkoutdues;





import React from 'react'
import {
    FormControl, Grid, TextField, Box, Button,
    Typography, Container, OutlinedInput, InputAdornment, Tooltip, Link,
    IconButton, Input, Paper,
    Autocomplete
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete'
import { Chip } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import axiosInstance from '../../lib/axios';
import PrintIcon from '@mui/icons-material/Print';
import Flag from '../../Components/Ragistration/Booking/Flag';
import moment from 'moment';
import BokingCModal from '../../Components/Ragistration/BConfirmation/BokingCModal';
import { useReactToPrint } from 'react-to-print';
import BReport from '../../atoms/ReportFolder/BReport';
import axiosInstanceForPG from '../../lib/axiosFormPG';
import CircularProgress from '@mui/material/CircularProgress';
import 'jspdf-autotable';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ConfirmationDialog from '../ReusableDailog';
import { useSelector } from 'react-redux';
import { selectGlobalProperty,selectGatewayType } from '../../redux/propertySlice';
import CancelIcon from '@mui/icons-material/Cancel';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import PrintCharges from './PrintCharges';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import UnbuildAdvice from '../CheckoutRequest/UnbuildAdvice';
import EmailIcon from '@mui/icons-material/Email';


const columns = [
    { id: 'BookId', label: 'BookId', minWidth: 50 },
    { id: 'BookNo', label: 'Booking No', minWidth: 120 },
    { id: 'BookDt', label: 'Book Date', minWidth: 130 },
    { id: 'BookSt', label: 'Status', minWidth: 130 },
    { id: 'ResidentName', label: 'Resident', minWidth: 130 },
    { id: 'MobileNo', label: 'Mobile', minWidth: 150 },
    { id: 'Duration', label: 'Duration', minWidth: 100 },
    { id: 'CheckinDt', label: 'CheckIn', minWidth: 100 },
    { id: 'CheckoutDt', label: 'CheckOut', minWidth: 100 },
];

function Checkoutdues(bookSt, onConfirm, bookId, onAccDetails, onAccGenerate) {
    const { register, watch, setValue, reset } = useForm();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [OpenLoader, setOpenLoader] = useState(false);
    const [TransactionData, setTransactionData] = useState([]);
    const [OpenHistoryTableDialog, setOpenHistoryTableDialog] = useState(false);
    const [AccGenerate, setAccGenerate] = useState(false);
    const [BookId, setBookId] = useState(-1);
    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [settlementDate, setSettlementDate] = useState(dayjs().format('DD/MM/YYYY'));
    const [rowsPerPage, setRowsPerPage] = useState(8);
    const [searchTerms, setSearchTerms] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [Mode, setMode] = useState('add');
    const [loadingPaymentLinks, setLoadingPaymentLinks] = useState({});
    const location = useLocation();
    const [showEarlyCheckoutWarning, setShowEarlyCheckoutWarning] = useState(false);
    const contentRef = useRef(null);
    const [hasUnpaidRent, setHasUnpaidRent] = useState(false);
    const [switchState, setSwitchState] = useState(false);
    const [emailResponse, setEmailResponse] = useState(null);
    const [isBookingConfirmed, setIsBookingConfirmed] = useState(false);
    const [isDepositPaid, setIsDepositPaid] = useState(false);
    const [openCheckoutConfirm, setOpenCheckoutConfirm] = useState(false);
    const [openCheckinConfirm, setOpenCheckinConfirm] = useState(false);
    const handlePrint = useReactToPrint({ contentRef });
    const globalProperty = useSelector(selectGlobalProperty);
    const [showPayAdvice, setShowPayAdvice] = useState(false);
    const baseUrl = window.location.origin;
    const [payAdvice, setPayAdvice] = useState([]);
    const [isCheckoutProcessing, setIsCheckoutProcessing] = useState(false);
    const [selectedCheckoutDate, setSelectedCheckoutDate] = useState(new Date().toLocaleDateString('en-GB'));
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [accountData, setAccountData] = useState([]);
    const [oldBedId, setOldBedId] = useState('');
    const [residentid, setResidentId] = useState(null);
    const [propId, setPropId] = useState(null);
    const [selectedData, setSelectedDate] = useState(new Date().toLocaleDateString('en-GB'));
    const [minCheckInDate, setMinCheckInDate] = useState(null);
    const [OthChrgDrp, setOthChrgDrp] = useState([]);
    const [isRefOth, setIsRefOth] = useState(false);
    const [amount, setAmount] = useState('');
    const [remark, setRemark] = useState('');
    const [discount, setDiscount] = useState('');
    const [totalAmount, setTotalAmount] = useState('');
    const [selectedCharge, setSelectedCharge] = useState(null);
    const [otherChargesList, setOtherChargesList] = useState([]);
    const [isPenaltyCalculated, setIsPenaltyCalculated] = useState(false);
    const [checkoutSettlementData, setCheckoutSettlementData] = useState(null);
    const [deletedCharges, setDeletedCharges] = useState([]);
    const [isButtondisable, setIsButtondisable] = useState(false)
    const [pendingAdvice, setPendingAdvice] = useState('')
     const gatewayType = useSelector(selectGatewayType);
    const isInitialLoad = useRef(true);

    useEffect(() => {
        const today = dayjs();
        const formattedToday = today.format('DD/MM/YYYY');

        setValue('CheckedOutDt', formattedToday);

        setSettlementDate(formattedToday);
        setSelectedCheckoutDate(formattedToday);

        setTimeout(() => {
            isInitialLoad.current = false;
        }, 200);
    }, []);


    useEffect(() => {

        if (watch('BookUpToDt') && watch('CheckedOutDt') && isInitialLoad.current) {
            setTimeout(() => {
                isInitialLoad.current = false;
            }, 100);
        }
    }, [watch('BookUpToDt'), watch('CheckedOutDt')]);


    useEffect(() => {

        const checkoutDateStr = settlementDate;
        const originalCheckoutStr = watch('BookUpToDt');


        if (isInitialLoad.current) return;

        if (checkoutDateStr && originalCheckoutStr) {
            const checkoutDate = dayjs(checkoutDateStr, 'DD/MM/YYYY');
            const originalCheckout = dayjs(originalCheckoutStr, ['DD/MM/YYYY', 'YYYY-MM-DD']);

            if (checkoutDate.isValid() && originalCheckout.isValid()) {
                const diffDays = originalCheckout.diff(checkoutDate, 'day');

                if (diffDays > 30) {
                    setShowEarlyCheckoutWarning(true);
                } else {
                    setShowEarlyCheckoutWarning(false);
                }
            }
        }
    }, [settlementDate, watch('BookUpToDt')]);  // Listen to settlementDate state


    const EarlyCheckoutWarningDialog = () => {
        const checkoutDate = watch('CheckedOutDt');
        const originalCheckout = watch('BookUpToDt');
        let diffDays = 0;

        if (checkoutDate && originalCheckout) {
            const checkout = dayjs(checkoutDate, 'DD/MM/YYYY');
            const original = dayjs(originalCheckout, ['DD/MM/YYYY', 'YYYY-MM-DD']);
            if (checkout.isValid() && original.isValid()) {
                diffDays = original.diff(checkout, 'day');
            }
        }

        return (
            <ConfirmationDialog
                open={showEarlyCheckoutWarning}
                onClose={() => setShowEarlyCheckoutWarning(false)}
                onConfirm={() => setShowEarlyCheckoutWarning(false)}
                title="Early Checkout Notice"
                message={`⚠️ This resident is checking out early (${Math.abs(diffDays)} days before the scheduled checkout date of ${originalCheckout}). Please ensure proper settlement of dues and refunds.`}
                confirmText="OK"
            />
        );
    };

    useEffect(() => {
        if (BookId !== -1 && !isCheckoutProcessing) {
            fetchPayAdvice(BookId);
            fetchPendingAdvice(BookId)
        }
    }, [BookId, isCheckoutProcessing]);

    useEffect(() => {
        // let MobileNo = location.state?.MobileNo;
        let BookId = location?.state?.BookId
        let ChkOutStlId = location?.state?.ChkOutStlId
        if (BookId) {
            // handleMobileChange(MobileNo, "B");
            fetchTransactionData(BookId);
        } else {
            setMode("add");
        }
        const fetchApi = async () => {
            setValue("CountryIcon", Flag);
            setValue("BookDt", "");
            setValue("BookDtFrom", "");
            setValue("BookUpToDt", "");
            // await fetchDataOfBooking();
            if (ChkOutStlId) {
                await fetchOtherCharges(ChkOutStlId);
            }
        };
        fetchApi();
    }, [location.state?.BookId, location.state?.ChkOutStlId]);

    const fetchTransactionData = async (bookId) => {
        if (!bookId) return;

        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/RetriveTrnBooking`, {
                BookId: bookId,
                Flag: "R",
                CreatedBy: UserId
            }
            );

            if (response.data.Status === 0) {
                setIsDataLoaded(true);
                const bookingData = response.data.Data[0];
                const {
                    BookSt, PropId, ResidentId, RoomBedId, CheckedOutDt, MobileNo, ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, CheckoutDt,
                    TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, CheckinDt, Email, PlanName, MonthlyAmt, BookStatus
                } = bookingData;
                setAccountData(bookingData);
                setOldBedId(RoomBedId);
                setResidentId(ResidentId);
                setPropId(PropId);
                setBookId(bookId);
                setValue("MobileNo", MobileNo);
                setValue("ResidentName", ResidentName);
                setValue("BookNo", BookNo);
                setValue("BookDt", BookDt);
                setValue("Duration", Duration);
                setValue("BookDtFrom", BookDtFrom);
                setValue("BookUpToDt", BookUpToDt);
                setValue("CheckoutDt", CheckoutDt);
                setValue("TopupAmt", TopupAmt);
                setValue("AdvcRcble", AdvcRcble);
                setValue("DiscAmt", DiscAmt);
                setValue("TotalRent", TotalRent);
                setValue("NetAmt", NetAmt);
                setValue("BedRent", BedRent);
                setValue("FreeMonth", FreeMonth);
                setValue("PropName", PropName);
                setValue("Email", Email);
                setValue("PlanName", PlanName);
                setValue("MonthlyAmt", MonthlyAmt);
                setValue("CheckinDt", CheckinDt)
                setValue('CheckedOutDt', CheckedOutDt)
                setSettlementDate(dayjs().format('DD/MM/YYYY'));
                if (BookSt === "C") {
                    setSelectedDate(CheckinDt);
                } else {
                    const currentDate = new Date().toISOString()?.split("T")[0];
                    const bookFromDateObj = new Date(BookDtFrom);
                    const currentDateObj = new Date(currentDate);
                    bookFromDateObj.setHours(0, 0, 0, 0);
                    currentDateObj.setHours(0, 0, 0, 0);
                    setSelectedDate(currentDateObj >= bookFromDateObj ? currentDate : BookDtFrom);
                }

                setMinCheckInDate(BookDtFrom);
                setAccGenerate(BookSt === "B");
                setTransactionData(response.data.Data);
                await fetchPayAdvice(bookId);
                await fetchPendingAdvice(bookId)
                await fetchRoomBedData(RoomBedId, BookDtFrom, BookUpToDt, PropId);
                await fetchServicesData(bookingData.TransPlanId, bookingData.MessPlanId);
            } else {
                setIsDataLoaded(false);
                toast.info("Booking Not Found");
                resetFuncM();
            }
        } catch (error) {
            toast.error("Failed to load booking data");
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchOtherCharges = async (ChkOutStlId) => {
        if (!ChkOutStlId) return;
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnChkOutStl/RetriveTrnChkOutStlAll`, {
                ChkOutStlId: ChkOutStlId,
                Flag: "R",
            });

            if (response.data.Status === 0) {
                setIsDataLoaded(true);
                setIsButtondisable(true);
                const mainData = response.data.Data.TrnChkOutStlDtlEntity[0];
                const chargesData = mainData?.trnChkOutStlDtlEntities || [];
                const apiCheckoutDate = mainData.ChkOutDt;
                let formattedCheckoutDate = '';
                const apiSettlementDate = mainData.ChkOutStlDt;
                if (apiCheckoutDate) {
                    formattedCheckoutDate = dayjs(apiCheckoutDate).format('DD/MM/YYYY');
                } else {
                    formattedCheckoutDate = dayjs().format('DD/MM/YYYY');
                }
                let formattedSettlementDate = '';
                if (apiSettlementDate) {
                    formattedSettlementDate = dayjs(apiSettlementDate).format('DD/MM/YYYY');
                    setSettlementDate(formattedSettlementDate);  // Set settlement date from API
                } else {
                    formattedSettlementDate = dayjs().format('DD/MM/YYYY');
                    setSettlementDate(formattedSettlementDate);
                }
                const checkoutSettlementData = {
                    ChkOutStlId: mainData.ChkOutStlId,
                    ChkOutStlNo: mainData.ChkOutStlNo,
                    BookId: mainData.BookId,
                    PropId: mainData.PropId,
                    ResidentId: mainData.ResidentId,
                    ChkOutDt: mainData.ChkOutDt,
                    ChkOutStlDt: mainData.ChkOutStlDt,
                    ChkOutBy: mainData.ChkOutBy,
                    TotalChrgAmt: mainData.ChrgAmt,
                    TotalDiscAmt: mainData.DiscAmt,
                    TotalNetAmt: mainData.NetAmt,
                    PytAdvId: mainData.PytAdvId,
                    RefundAdvId: mainData.RefundAdvId,
                    Status: mainData.Status,
                    Remark: mainData.Remark,
                    CreatedDt: mainData.CreatedDt,
                    CreatedBy: mainData.CreatedBy,
                    PropName: mainData.PropName,
                    BookNo: mainData.BookNo,
                    BookDt: mainData.BookDt,
                    ResidentName: `${mainData.FirstName} ${mainData.MidName || ''} ${mainData.LastName}`.trim(),
                    PytAdvNo: mainData.PytAdvNo,
                    DBFLAG: mainData.DBFLAG
                };
                const formattedCharges = chargesData.map(charge => ({
                    id: charge.ChkOutStlDtlId,
                    chargeId: charge.OthChrgId,
                    chargeName: charge.ChrgName,
                    amount: parseFloat(charge.ChrgAmt) || 0,
                    discount: parseFloat(charge.DiscAmt) || 0,
                    netAmount: parseFloat(charge.NetAmt) || 0,
                    ChkOutStlDtlId: charge.ChkOutStlDtlId,
                    OthChrgId: charge.OthChrgId,
                    ChrgAmt: charge.ChrgAmt,
                    DiscAmt: charge.DiscAmt,
                    NetAmt: charge.NetAmt,
                    ChrgName: charge.ChrgName,
                    remark: charge.Remark || '',
                    DBFLAG: charge.DBFLAG
                }));
                setCheckoutSettlementData(checkoutSettlementData);
                setOtherChargesList(formattedCharges);
                if (formattedCharges.length > 0) {
                    setIsPenaltyCalculated(true);
                }
                setValue("PropName", mainData.PropName);
                setValue("BookNo", mainData.BookNo);
                setValue("CheckedOutDt", formattedCheckoutDate);
                setValue("BookDt", mainData.BookDt);
                setValue("ResidentName", `${mainData.FirstName} ${mainData.MidName || ''} ${mainData.LastName}`.trim());
                setValue("Remark", mainData.Remark);
            } else {
                setIsDataLoaded(false);
                setIsButtondisable(false);
                toast.info("Booking Not Found");
                resetFuncM();
            }
        } catch (error) {
            toast.error("Failed to load booking data");
        } finally {
            setOpenLoader(false);
        }
    };
    useEffect(() => {
        fetchOtherCharges()
    }, [])

    const fetchPayAdvice = async (BookId) => {
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                "PytAdvDt": moment().format("YYYY-MM-DD"),
                "Flag": "GenPytAdv",
                "BookId": BookId
            });

            if (response.data.Status === 0) {
                setPayAdvice(response.data.Data);
                setShowPayAdvice(true);

                const unpaidRentExists = response.data.Data.some(
                    item => item.PytAdvFor === "R" && item.IsDepPaid !== "Y"
                );
                const firstInstallmentPaid = response.data.Data.some(
                    item => item.PytAdvFor === "R" &&
                        item.Remark?.includes("Installment 1") &&
                        item.IsDepPaid === "Y"
                );

                setHasUnpaidRent(unpaidRentExists && !firstInstallmentPaid);
            }
        } catch (error) {
            toast.error('Error fetching payment advice:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    const fetchPendingAdvice = async (BookId) => {
        console.log('BookId', BookId)
        try {
            setOpenLoader(true);
            const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
                "PytAdvDt": moment().format("YYYY-MM-DD"),
                "Flag": "UnBilledAdvPyt",
                "BookId": BookId
            });

            if (response.data.Status === 0) {
                setPendingAdvice(response.data.Data);
                setShowPayAdvice(true);

                const unpaidRentExists = response.data.Data.some(
                    item => item.PytAdvFor === "R" && item.IsDepPaid !== "Y"
                );
                const firstInstallmentPaid = response.data.Data.some(
                    item => item.PytAdvFor === "R" &&
                        item.Remark?.includes("Installment 1") &&
                        item.IsDepPaid === "Y"
                );

                setHasUnpaidRent(unpaidRentExists && !firstInstallmentPaid);
            }
        } catch (error) {
            toast.error('Error fetching payment advice:', error);
        } finally {
            setOpenLoader(false);
        }
    };

    useEffect(() => {
        if (TransactionData.length > 0) {
            const { MobileNo, ResidentName, CheckinDt, BookNo, CheckoutDt, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, BookId, PropName, Email, PropId } = TransactionData[0];
            let obj = { ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, MobileNo, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, Email, CheckinDt, PropId }

            setValue("MonthlyAmt", Math.round(NetAmt / Duration));
            setObjValue(obj);
            setValue("Email", Email);
            setValue("PropId", PropId);
            setValue("CheckinDt", CheckinDt)
            setBookId(BookId)
            const fetchDataAndSet = async () => {
                await fetchRoomBedData(TransactionData[0].RoomBedId, TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, TransactionData[0].PropId);
                await fetchPlanData(TransactionData[0].RoomPlanId);
                await fetchServicesData(TransactionData[0].TransPlanId, TransactionData[0].MessPlanId);
            }
            fetchDataAndSet();
            setNetAmount();
        }
    }, [TransactionData, globalProperty]);

    useEffect(() => {
        const today = dayjs();
        const formattedToday = today.format('DD/MM/YYYY');
        setValue('CheckoutDt', formattedToday);
        setSelectedCheckoutDate(formattedToday);
    }, []);

    const handleSearchChange = (columnId, value) => {
        setSearchTerms(prev => ({ ...prev, [columnId]: value }));
        setPage(0);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const filteredRows = React.useMemo(() => {
        return rows.filter(row => {
            return Object.entries(searchTerms).every(([columnId, term]) => {
                if (!term) return true;
                const value = row[columnId];
                if (typeof value === 'string') {
                    return value.toLowerCase().includes(term.toLowerCase());
                } else if (typeof value === 'number') {
                    return value.toString().includes(term);
                }
                return true;
            });
        });
    }, [searchTerms, rows]);

    const fetchDataOfBooking = async () => {
        try {
            setIsPenaltyCalculated(false)
            const response = await axiosInstance.post(
                `TrnBooking/GetTrnBookingDashBoard`,
                {
                    PageNumber: 1,
                    PageSize: 0,
                    SearchText: '',
                    Flag: 'PendChkStl',
                    MobileNo: '',
                    BookNo: '',
                    PropId: globalProperty,
                }
            );

            if (response.data.Status === 0) {
                const formattedData = response.data.Data.map(checkout => ({
                    ...checkout,
                    BookSt: checkout.BookSt === "O" ? "CheckedIn" : checkout.BookSt === "X" ? "Cancel" : ""
                }));
                setRows(formattedData);
            } else {
                toast.error('Error fetching Grid data:', response.data.Message);
                setRows([]);
            }
        } catch (error) {
            toast.error('Error fetching Booking data:', error);
        }
    };

    const handleMobileChange = async (e, Separator) => {
        let val = "";
        if (Separator === "A") {
            val = e.target.value.trim()
        } else {
            val = e.trim();
        }

        if (val.length >= 10) {
            try {
                setIsPenaltyCalculated(false)
                const response = await axiosInstance.post(
                    `TrnBooking/GetTrnBookingDashBoard`,
                    {
                        "start": 1,
                        "PageSize": 1,
                        "SearchText": 'PendChkStl',
                        "Flag": '',
                        "MobileNo": val,
                        "BookNo": '',
                        "PropId": 1,
                    }
                );

                if (response.data.Status === 0) {
                    setIsDataLoaded(true);
                    const { BookSt, IsDepPaid } = response.data.Data[0];
                    const data = response.data.Data[0]
                    setAccountData(data);
                    setIsDepositPaid(IsDepPaid === "Y");
                    setIsBookingConfirmed(BookSt === "O");
                    setSwitchState(BookSt === "O");
                    if (BookSt === "B") {
                        setAccGenerate(false);
                    } else {
                        setAccGenerate(true);
                    }
                    setTransactionData(response.data.Data);
                    setOtherChargesList([]);
                    await fetchPayAdvice(response.data.Data[0].BookId);
                    await fetchPendingAdvice(response.data.Data[0].BookId);
                } else {
                    setIsDataLoaded(false);
                    toast.info("Booking Doesn't Exist On This Number");
                    resetFuncM();
                    setValue("BookNo", "");
                    setBookId(-1);
                }
            } catch (error) {
                toast.error('Error fetching data:', error);
            }
        } else if (val.length === 9) {
            resetFuncM();
            setValue("BookNo", "");
            setBookId(-1);
        }
        Separator === "B" && handleClose();
    };

    const handleBookNoChange = async (e, Separator) => {
        let val = "";
        if (Separator === "A") {
            val = e.target.value.trim()
        } else {
            val = e.trim();
        }

        if (val.length >= 8) {
            try {
                setIsPenaltyCalculated(false)
                const response = await axiosInstance.post(
                    `TrnBooking/GetTrnBookingDashBoard`,
                    {
                        "start": 1,
                        "PageSize": 1,
                        "SearchText": 'PendChkStl',
                        "Flag": '',
                        "MobileNo": '',
                        "BookNo": val,
                        "PropId": 1,
                    }
                );

                if (response.data.Status === 0) {
                    setIsDataLoaded(true);
                    setIsButtondisable(true)
                    const { BookSt, IsDepPaid } = response.data.Data[0];
                    setIsDepositPaid(IsDepPaid === "Y");
                    setIsBookingConfirmed(BookSt === "O");
                    setSwitchState(BookSt === "O");

                    if (BookSt === "B") {
                        setAccGenerate(true);

                    } else {
                        setAccGenerate(false);
                    }
                    setTransactionData(response.data.Data);
                    setOtherChargesList([]);
                    await fetchPayAdvice(response.data.Data[0].BookId);
                    await fetchPendingAdvice(response.data.Data[0].BookId);
                } else {
                    setIsButtondisable(false)
                    toast.info("Booking Doesn't Exist On This Number");
                    resetFuncM();
                    setValue("MobileNo", "");
                    setBookId(-1);
                }
            } catch (error) {
                setIsButtondisable(false)
                toast.error('Error fetching Booking data:', error);
            }
        } else if (val.length === 7) {
            setIsDataLoaded(false);
            resetFuncM();
            setValue("MobileNo", "");
        }
        Separator === "B" && handleClose();
    }

    const fetchRoomBedData = async (RoomBedId, date1, date2, PropId) => {
        try {
            const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
                BookFromDt: date1,
                BookToDt: date2,
                PropId: PropId,
                Flag: "",
                RoomBedId: RoomBedId
            });

            if (response.data.Status === 0) {
                handleRowDoubleClick(response.data.Data[0]);
            }
        } catch (error) {
            toast.error('Error fetching company data:', error);
        }
    };

    const fetchPlanData = async (PlanId) => {
        try {
            const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
                "RoomPlanID": PlanId,
                "Flag": "R"
            });

            if (response.data.Status === 0) {
                setPlanData(response.data.Data);
            }
        } catch (error) {
            toast.error('Error fetching company data:', error);
        }
    };

    const handleRowDoubleClick = async (row) => {
        const { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, } = row;
        const obj = { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, };
        setObjValue(obj);
    };

    const setPlanData = (PlanArr) => {
        const { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt } = PlanArr[0];
        const obj = { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt };
        setObjValue(obj);
    }


    const setObjValue = (obj) => {
        for (let key in obj) {
            setValue(key, obj[key]);
        }
    }

    const handleClose = () => {
        setOpenHistoryTableDialog(false);
        setPage(0);
        setTimeout(() => {
            setSearchTerms({});
        }, [500]);

    };

    const handleClickCheckAva = async () => {
        await fetchDataOfBooking();
        setOpenHistoryTableDialog(true);
    };

    const setNetAmount = () => {
        setValue("TotalAmt", ((watch("TAmount") || 0) + (watch("MAmount") || 0) + (watch("TopupAmt") || 0) + (watch("AdvcRcble") || 0)));
    };

    const fetchServicesData = async (TransPlanId, MessPlanId) => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(
                `MstTransPlan/getMstTransPlandrp`,
                { Flag, UserId },
            );

            if (response.data.Status === 0) {
                // setTransPlanDrp(response.data.Data);
                let obj = response.data.Data.find(obj => obj.TransPlanID === TransPlanId);
                if (obj) {
                    setValue("TAmount", obj.Amount);
                } else {
                    setValue("TAmount", 0);
                }
                setNetAmount()
            } else {
                toast.error('Error fetching Trans data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
        try {
            const response = await axiosInstance.post(
                `MstMessPlan/getMstMessPlandrp`,
                { Flag, UserId },
            );

            if (response.data.Status === 0) {

                let obj = response.data.Data.find(obj => obj.MessPlanID === MessPlanId);
                if (obj) {
                    setValue("MAmount", obj.Amount);
                } else {
                    setValue("MAmount", 0);
                }
                setNetAmount();
            } else {
            }
        } catch (error) {
            toast.error('Error fetching Plan data');
        }
    }
    const resetFuncM = () => {
        const obj = {
            "ResidentName": "",
            "BookDt": "",
            "Duration": "",
            "BookDtFrom": "",
            "BookUpToDt": "",
            "WingName": "",
            "FloorName": "",
            "RoomTypeName": "",
            "RoombedName": "",
            "RoomBedTypeName": "",
            "BedRent": "",
            "PlanName": "",
            "PlanTenur": "",
            "FreeMonth": "0",
            "LastAdjMonths": "0",
            "IncRentPerc": "",
            "DepositAmt": "",
            "TopupAmt": "",
            "Tamt": "",
            "MAmount": "",
            "TAmount": "",
            "TotalRent": "",
            "DiscAmt": "",
            "NetAmt": "",
            "MonthlyAmt": "",
            "PropName": "",
            "CheckedOutDt": dayjs().format('DD/MM/YYYY'),
        }
        for (let key in obj) {
            setValue(key, "")
        }
        setValue("CountryIcon", Flag);
        setSelectedCharge(null);
        setAmount('');
        setRemark('')
        setDiscount('');
        setTotalAmount('');
        setOtherChargesList([]);
        setIsSubmitting(false);
        setSelectedCheckoutDate(dayjs().format('DD/MM/YYYY'));
    };



    const handleCheckoutConfirm = async () => {
        setOpenLoader(true);
        setOpenCheckoutConfirm(false);
        setIsCheckoutProcessing(true);

        try {
            const checkoutDate = watch('CheckedOutDt');
            const formattedDate = dayjs(checkoutDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
            const response = await axiosInstance.post(
                `TrnBooking/TrnBookingConfirmation`,
                {
                    "BookId": BookId,
                    "CreatedBy": UserId,
                    "Flag": "L",
                    // "CreatedDate": TransactionData[0].CheckoutDt
                    "CreatedDate": formattedDate,
                },
            );

            if (response.data.Status === 0) {
                toast.success("CheckOut Successfully");
                setTransactionData(prevData =>
                    prevData.map(item => ({
                        ...item,
                        BookSt: "L"
                    }))
                );
                setSwitchState(false);
                setIsBookingConfirmed(false);
            } else {
                toast.error(response.data.Message || "Operation failed");
            }
        } catch (error) {
            toast.error('Error fetching CheckIn data');
        } finally {
            setOpenLoader(false);
            setIsCheckoutProcessing(false);
        }
    };

    const handleCheckInClick = () => {
        if (BookId === -1) {
            toast.info("Nothing Any Transaction Is Visible");
            return;
        }

        setOpenCheckinConfirm(true);
    };

    const handleCheckinConfirm = async () => {
        setOpenLoader(true);
        setOpenCheckinConfirm(false);

        try {
            const response = await axiosInstance.post(
                `TrnBooking/TrnBookingConfirmation`,
                {
                    "BookId": BookId,
                    "CreatedBy": UserId,
                    "Flag": "O"
                },
            );

            if (response.data.Status === 0) {
                toast.success("Checkout Cancel Successfully");
                setTransactionData(prevData =>
                    prevData.map(item => ({
                        ...item,
                        BookSt: "O"
                    }))
                );
                setSwitchState(true);
                setIsBookingConfirmed(true);

                await fetchPayAdvice(BookId);
                await fetchPendingAdvice(BookId)

            } else {
                toast.error(response.data.Message || "Operation failed");
            }
        } catch (error) {
            toast.error('Error fetching CheckIn data');
        } finally {
            setOpenLoader(false);
        }
    };

    const formatDate = (date) => {
        if (!date || !moment(date).isValid()) return '';
        return moment(date).format('DD/MM/YYYY');
    };
    const handleSendPaymentLink = async (item) => {
    try {
        setIsLoading(true);
        setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: true }));
        const userId = parseInt(sessionStorage.getItem('UserId'));
        const baseUrl = window.location.origin;
       
        // const gatewayType = gatewayType || 'CashFree';
        let paymentResponse = null;

        if (gatewayType === 'CashFree') {
            const paymentDetails = {
                customer_details: {
                    customer_email: item.Email,
                    customer_name: item.ResidentName,
                    customer_phone: item.MobileNo
                },
                link_amount: item.Amount || 0,
                link_auto_reminders: true,
                link_currency: "INR",
                link_expiry_time: "2026-06-09T15:04:05+05:30",
                link_id: "Testing9062026",
                link_meta: {
                    notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                    return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
                    upi_intent: false
                },
                link_minimum_partial_amount: parseFloat(item.Amount),
                link_notes: {
                    key_1: "CashFreepay",
                    key_2: "linkCashfree"
                },
                link_notify: {
                    send_email: false,
                    send_sms: true
                },
                link_partial_payments: true,
                link_purpose: item.Remark,
                ResidentId: item.ResidentId,
                Flag: "Active",
                Remark: "Testing",
                TrjType: "TrnPytAdv",
                TrjDocNo: item.PytAdvNo,
                TrjDocId: item.BookId,
                cf_payment_id: "",
                payment_status: "",
                PropId: item.PropId
            };

            const response = await axiosInstanceForPG.post(
                `PaymentGatewayLog/CreateCashFreeLink`,
                paymentDetails,
            );

            if (response.data.Status == 0) {
                setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                setIsLoading(false);
                return toast.success(response.data.Message);
            }
            if (response.data.Status == 1) {
                setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                setIsLoading(false);
                return toast.error(response.data.Message);
            }

            paymentResponse = response.data;
            if (typeof paymentResponse === 'string') {
                paymentResponse = JSON.parse(paymentResponse);
            }

            if (!paymentResponse || !paymentResponse.link_url) {
                console.error("Invalid payment response:", paymentResponse);
                toast.error("Failed to create payment link");
                setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                setIsLoading(false);
                return;
            }

        } else if (gatewayType === 'Instamojo') {
            const paymentDetails = {
                purpose: item.Remark || `Payment Advice ${item.PytAdvNo}`,
                amount: item.Amount || 0,
                buyer_name: item.ResidentName || '',
                email: item.Email || '',
                phone: item.MobileNo || '',
                redirect_url: `${baseUrl}/payment-success`,
                redirecturl: `${baseUrl}/payment-success/`,
                webhook_url: '',
                ResidentId: item.ResidentId,
                TrjDocId: item.PytAdvId || 0,
                TrjType: "TrnPytAdv",
                TrjDocNo: item.PytAdvNo || '',
                PropId: item.PropId || 0,
            };

            const response = await axiosInstanceForPG.post(
                `Payment/CreatePaymentOrder`,
                paymentDetails,
            );
            if (response.data.Status == 1) {
                setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                setIsLoading(false);
                return toast.error(response.data.Message);
            }

            if (response.data.Status === 0) {
                setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                setIsLoading(false);
                return toast.success(response.data.Message);
            }

            paymentResponse = JSON.parse(response.data);

            if (!paymentResponse || !paymentResponse.payment_request || !paymentResponse.payment_request.longurl) {
                console.error("Invalid payment response:", paymentResponse);
                toast.error("Failed to create payment link");
                setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
                setIsLoading(false);
                return;
            }

        } else {
            toast.error(`Unsupported gateway type: ${gatewayType}`);
            setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
            setIsLoading(false);
            return;
        }
        const paymentToken = gatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
        const paymentUrl = gatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl;
        setEmailResponse(paymentUrl);
        const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;

        let paymentLogPayload;
        if (gatewayType === 'CashFree') {
            paymentLogPayload = {
                id: paymentResponse.link_id,
                cf_link_id: paymentResponse.cf_link_id,
                phone: paymentResponse.customer_details.customer_phone,
                email: paymentResponse.customer_details.customer_email,
                buyer_name: paymentResponse.customer_details.customer_name || 'null',
                amount: paymentResponse.link_amount,
                purpose: paymentResponse.link_purpose,
                expires_at: null,
                status: paymentResponse.link_status,
                send_sms: paymentResponse.link_notify.send_sms,
                send_email: paymentResponse.link_notify.send_email,
                sms_status: 'null',
                email_status: 'null',
                shorturl: 'null',
                longurl: paymentResponse.link_url,
                redirect_url: paymentResponse.link_meta.return_url,
                webhook: 'null',
                allow_repeated_payments: true,
                created_at: paymentResponse.link_created_at,
                modified_at: paymentResponse.link_created_at,
                ResidentId: item.ResidentId,
                link_qrcode: paymentResponse.link_qrcode,
                TrjDocNo: item.PytAdvNo,
                TrjDocId: item.PytAdvId,
                TrjType: "TrnPytAdv",
                Flag: "Active",
                Remark: "Payment Link for Payment Advice",
                Gatewaytype: "CashFree",
            };
        } else {
            paymentLogPayload = {
                id: paymentResponse.payment_request.id,
                phone: paymentResponse.payment_request.phone,
                email: paymentResponse.payment_request.email,
                buyer_name: paymentResponse.payment_request.buyer_name,
                amount: paymentResponse.payment_request.amount,
                purpose: paymentResponse.payment_request.purpose,
                expires_at: paymentResponse.payment_request.expires_at,
                status: paymentResponse.payment_request.status,
                send_sms: paymentResponse.payment_request.send_sms,
                send_email: paymentResponse.payment_request.send_email,
                sms_status: paymentResponse.payment_request.sms_status,
                email_status: paymentResponse.payment_request.email_status,
                shorturl: paymentResponse.payment_request.shorturl,
                longurl: paymentResponse.payment_request.longurl,
                redirect_url: paymentResponse.payment_request.redirect_url,
                webhook: paymentResponse.payment_request.webhook,
                allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
                created_at: paymentResponse.payment_request.created_at,
                modified_at: paymentResponse.payment_request.modified_at,
                ResidentId: item.ResidentId,
                TrjDocNo: item.PytAdvNo,
                TrjDocId: item.PytAdvId,
                TrjType: "TrnPytAdv",
                Flag: "Active",
                Remark: "Payment Link for Payment Advice",
                Gatewaytype: "Instamojo",
            };
        }

        await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload);

        const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${item.PytAdvNo}]`;
        const Body = `Hey <strong>${item.ResidentName}</strong>,<br><br>
        We would like to inform you that payment advice has been created for you tenancy at <strong>${item.PropName}</strong>.Please find attached your payment advice with this email <br><br>
        Following are the details : <br><br>
        Advice No: <strong>${item.PytAdvNo}</strong><br>
        Amount: <strong>${item.Amount}</strong><br>
        Date Of Issue: <strong>${formatDate(item.PytAdvDt)}</strong><br>
        Due Date: <strong>${formatDate(item.DueDt)}</strong><br>
        Advice For: <strong>${item.Remark}</strong><br>
        <strong>Payment Link:</strong> <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
        We hope you are having a pleasant stay with us. Do let us know if you need any assitance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
        Cheers,<br>
        Team Clanbridge`;

        const emailRequest = {
            ToEmail: item.Email ? [item.Email] : [],
            Subject,
            Body,
            Attachments: '',
            attachmentFilePaths: [],
            PropId: item.PropId,
            UserId: userId,
        };

        const emailResponse = await axiosInstanceForPG.post(
            `EmailRequest/SendEmail`,
            emailRequest,
        );

        if (emailResponse.data.Status === 0) {
            toast.success(`Payment Link Sent Successfully for ${item.PytAdvNo}`);
        } else {
            toast.info(emailResponse.data.Message);
        }
        // fetchPayAdvice(activeView === 'advice' ? 'GenPytAdv' : 'BookingWise');

    } catch (error) {
        console.error('Error sending payment link:', error);
        toast.error(error.response?.data?.Message || "Failed to send payment link");
    } finally {
        setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
        setIsLoading(false);
    }
};


    useEffect(() => {
        if (watch("OthChrgId") && OthChrgDrp.length > 0) {
            const foundCharge = OthChrgDrp.find(charge => charge.Id === parseInt(watch("OthChrgId")));
            if (foundCharge) {
                setSelectedCharge(foundCharge);
            }
        }
    }, [OthChrgDrp, watch("OthChrgId")]);
    const fetchOthCharges = async () => {
        setIsRefOth(true);
        try {
            const response = await axiosInstance.post(`MstOthChrg/GetMstOthChrgDrp`);
            if (response.data?.Data) {
                const mappedChargeData = response.data.Data.map((item) => ({
                    Id: item.OthChrgId,
                    Name: item.ChrgName,
                }));
                setOthChrgDrp(mappedChargeData);
            } else {
                toast.error("Failed to fetch Other Charges");
            }
        } catch (error) {
            console.error("Error fetching Other Charges:", error);
            toast.error("Error fetching Other Charges.");
        } finally {
            setTimeout(() => {
                setIsRefOth(false);
            }, 300);
        }
    };

    useEffect(() => {
        fetchOthCharges();
    }, []);
    const openOth = () => {
        window.open("/othercharges");
    }
    useEffect(() => {
        const amt = parseFloat(amount) || 0;
        const disc = parseFloat(discount) || 0;
        const calculatedTotal = amt - disc;
        setTotalAmount(calculatedTotal > 0 ? calculatedTotal : 0);
    }, [amount, discount]);

    const handleChargeChange = (event, newValue) => {
        setSelectedCharge(newValue);
        setValue("OthChrgId", newValue?.Id || "");
    };

    const handleAddCharge = () => {
        if (!selectedCharge) {
            toast.error("Please select a charge first");
            return;
        }

        const chargeExists = otherChargesList.some(item =>
            item.chargeId === selectedCharge.Id ||
            item.OthChrgId === selectedCharge.Id
        );
        if (chargeExists) {
            toast.error("This charge has already been added");
            return;
        }


        const isEarlyCheckoutRefund = selectedCharge.Name === "Early Checkout Amount (Refund)" ||
            selectedCharge.Id === 8;

        const chargeAmount = parseFloat(amount) || 0;
        const chargeDiscount = parseFloat(discount) || 0;
        const netAmount = chargeAmount - chargeDiscount;

        const newCharge = {
            id: Date.now(),
            chargeId: selectedCharge.Id,
            chargeName: selectedCharge.Name,
            amount: chargeAmount,
            discount: chargeDiscount,
            netAmount: isEarlyCheckoutRefund ? -Math.abs(netAmount) : netAmount,
            isNegative: isEarlyCheckoutRefund,
            remark: remark || '',
            DBFLAG: isEarlyCheckoutRefund ? "-" : "+"
        };

        setOtherChargesList(prev => [...prev, newCharge]);
        setSelectedCharge(null);
        setAmount('');
        setRemark('')
        setDiscount('');
        setTotalAmount('');
        setIsPenaltyCalculated(false);
    };

    const handleDeleteCharge = (id) => {
        setOtherChargesList(prev => {
            const chargeToDelete = prev.find(item => item.id === id);
            if (chargeToDelete && chargeToDelete.ChkOutStlDtlId) {
                setDeletedCharges(prevDeleted => [...prevDeleted, {
                    ...chargeToDelete,
                    DBFLAG: "D"
                }]);
            }

            return prev.filter(item => item.id !== id);
        });
        toast.success("Charge removed from list");
    };
    const totalChargesAmount = otherChargesList?.reduce((sum, item) => {
        const netAmount = item.NetAmt !== undefined ? parseFloat(item.NetAmt) : parseFloat(item.netAmount || 0);

        const isNegative = item.DBFLAG === "-" || item.isNegative || netAmount < 0;

        if (isNegative) {
            return sum - Math.abs(netAmount);
        } else {
            return sum + Math.abs(netAmount);
        }
    }, 0);

    const handleCalculateCharges = async () => {
        const payload = {
            "BookId": BookId,
            "Flag": "",
            "PenaltyAmt": 0
        }
        try {
            const response = await axiosInstance.post(`TrnBooking/CalcPenalty`, payload);
            if (response.data.Status === 0 && response.data.Data) {
                // Filter out Security Deposit and prevent duplicates
                const existingChargeIds = otherChargesList.map(charge => charge.chargeId);

                const penaltyCharges = response.data.Data
                    .filter(item => item.Amount !== 0)
                    // Remove Security Deposit from API response to prevent duplicates
                    // .filter(item => item.ChrgName !== "Security Deposit")
                    .map((item, index) => {
                        const isNegative = item.DBFLAG === "-" || parseFloat(item.Amount) < 0;
                        const amountValue = Math.abs(parseFloat(item.Amount)) || 0;
                        return {
                            id: `${index}-${Date.now()}`,
                            chargeId: item.OthChrgId || '0',
                            chargeName: item.ChrgName || (isNegative ? "Refund" : "Charge"),
                            amount: amountValue,
                            discount: 0,
                            netAmount: isNegative ? -amountValue : amountValue,
                            originalAmount: parseFloat(item.Amount),
                            DBFLAG: item.DBFLAG,
                            isNegative: isNegative
                        };
                    })
                    // Filter out any charges that already exist (by chargeId)
                    .filter(newCharge =>
                        !existingChargeIds.includes(newCharge.chargeId) &&
                        !otherChargesList.some(existingCharge =>
                            existingCharge.chargeName === newCharge.chargeName &&
                            existingCharge.isNegative === newCharge.isNegative
                        )
                    );

                if (penaltyCharges?.length > 0) {
                    setOtherChargesList(prev => [...prev, ...penaltyCharges]);
                    setIsPenaltyCalculated(true);
                    toast.success(`Added ${penaltyCharges.length} charge(s) successfully`);
                } else {
                    toast.info("No new charges found to add");
                }
            } else {
                toast.error("No penalty data found");
            }
        } catch (error) {
            console.error("Error calculating penalty:", error);
            toast.error("Error calculating charges");
        }
    }

    const handleSubmitdata = async () => {
        if (isSubmitting) return;
        const articleLossChargeId = 2;
        const hasArticleDamage = TransactionData &&
            TransactionData.length > 0 &&
            TransactionData[0]?.ChkArtId > 0;

        const hasArticleChargeAdded = otherChargesList.some(charge =>
            charge.chargeId === articleLossChargeId
        );

        if (hasArticleDamage && !hasArticleChargeAdded) {
            toast.error("Please add 'Articles checkout handover and Artical Loss & Damage Charges' before submitting");
            return;
        }


        setIsSubmitting(true);
        const chargesEntities = otherChargesList.map(charge => {
            const dbFlag = charge.ChkOutStlDtlId ? "U" : "I";

            return {
                "DBFLAG": dbFlag,
                "ChkOutStlDtlId": charge.ChkOutStlDtlId || 0,
                "ChkOutStlId": checkoutSettlementData?.ChkOutStlId || 0,
                "OthChrgId": charge.chargeId === '0' ? '5' : charge.chargeId,
                "ChrgAmt": charge.amount || charge.ChrgAmt || 0,
                "DiscAmt": charge.discount || 0,
                "NetAmt": charge.netAmount || charge.NetAmt || 0
            };
        });

        const deletedChargesEntities = deletedCharges.map(charge => ({
            "DBFLAG": "D",
            "ChkOutStlDtlId": charge.ChkOutStlDtlId || 0,
            "ChkOutStlId": checkoutSettlementData?.ChkOutStlId || 0,
            "OthChrgId": charge.chargeId === '0' ? '5' : charge.chargeId,
            "ChrgAmt": charge.amount || charge.ChrgAmt || 0,
            "DiscAmt": charge.discount || 0,
            "NetAmt": charge.netAmount || charge.NetAmt
        }));

        const allChargesEntities = [...chargesEntities, ...deletedChargesEntities];

        const mainDBFlag = checkoutSettlementData?.ChkOutStlId ? "U" : "I";

        // Get actual checkout date (when resident checked out)
        const actualCheckoutDate = watch('CheckedOutDt');
        let formattedCheckoutDate = '';
        if (actualCheckoutDate) {
            formattedCheckoutDate = dayjs(actualCheckoutDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
        } else {
            formattedCheckoutDate = dayjs().format('YYYY-MM-DD');
        }

        // Get settlement date from state (date user selected in DatePicker)
        let formattedSettlementDate = '';
        if (settlementDate) {
            formattedSettlementDate = dayjs(settlementDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
        } else {
            formattedSettlementDate = dayjs().format('YYYY-MM-DD');
        }


        const payload = {
            "DBFLAG": mainDBFlag,
            "ChkOutStlId": checkoutSettlementData?.ChkOutStlId || 0,
            "BookId": BookId,
            "PropId": propId || TransactionData[0]?.PropId || 0,
            "ResidentId": residentid || TransactionData[0]?.ResidentId || 0,
            "ChkOutDt": formattedCheckoutDate,
            "ChkOutStlDt": formattedSettlementDate,
            "ChkOutBy": parseInt(UserId),
            "PytAdvId": TransactionData[0]?.PytAdvId || 1,
            "RefundAdvId": 1,
            "Remark": "Api test",
            "Status": "1",
            "Created_By": parseInt(UserId),
            "trnChkOutStlDtlEntities": allChargesEntities
        };

        try {
            const response = await axiosInstance.post(`TrnChkOutStl/MangeTrnChkOutStl`, payload);
            if (response.data.Status === 0) {
                toast.success(response.data.Message);
                setCheckoutSettlementData(null);
                setDeletedCharges([]);
            } else {
                toast.error(response.data.Message || "Operation failed");
                setIsSubmitting(false);
            }
        } catch (error) {
            toast.error('Error submitting checkout settlement');
            console.error('Submission error:', error);
            setIsSubmitting(false);
        }
    };

    const handleCalculate = async () => {
        const payload = {
            "BookId": BookId,
            "ResidentId": residentid || TransactionData[0]?.ResidentId || 0,
            "PropId": propId || TransactionData[0]?.PropId,
            "Amount": Math.abs(totalChargesAmount),
            "CreatedBy": parseInt(UserId),
            "Flag": ""
        }
        try {

            const response = await axiosInstance.post(`TrnBooking/InsertCalcPenalty`, payload);
            if (response.data.Status === 0 && response.data.Data) {
                toast.success('Settelment Calculated Successfully')
                await fetchPayAdvice(BookId);
                await fetchPendingAdvice(BookId)
            } else {
                toast.error("No penalty data found");
            }
        } catch (error) {
            console.error("Error calculating penalty:", error);
            toast.error("Error calculating penalty charges");
        }
    }
    const handleExitClick = () => {
        navigate('/checkout/checkoutduetable')
    }



    const handleDeleteCharges = async () => {
        setOpenCheckinConfirm(false);

        if (!checkoutSettlementData?.ChkOutStlId) {
            toast.error("No charges to delete");
            return;
        }

        const payload = {
            "ChkOutStlId": checkoutSettlementData.ChkOutStlId,
            "ActionBy": parseInt(UserId)
        }

        try {
            const result = await axiosInstance.post('TrnChkOutStl/DeleteTrnChkOutStl', payload)
            if (result.data.Status === 0) {
                toast.success(result.data.Message)
                setOtherChargesList([]);
                setCheckoutSettlementData(null);
                setIsPenaltyCalculated(false);
                await fetchOtherCharges();

            } else {
                toast.error(result.data.Message || "Failed to delete charges");
            }
        } catch (error) {
            toast.error('Something went wrong while deleting charges')
            console.error('Delete error:', error);
        }
    }
    useEffect(() => {
        setIsSubmitting(false);
    }, [otherChargesList]);

    const handleSendDuesEmail = async () => {
        try {
            setIsLoading(true);
            const userId = parseInt(sessionStorage.getItem('UserId'));
            const requestCheckoutDate = watch('ReqCheckoutDt');
            const expectedCheckoutDate = watch('expectedcheckout');
            const reason = watch('Resion') || 'Not specified';
            const residentName = watch('ResidentName');
            const residentId = residentid || TransactionData[0]?.ResidentId || 0;
            const propertyName = watch('PropName');
            const bookingNo = watch('BookNo');
            const email = watch('Email');

            const formData = {
                bookingNo,
                residentId,
                residentName,
                propertyName,
                requestCheckoutDate,
                expectedCheckoutDate,
                reason,
                bookId
            };
            const encodedData = encodeURIComponent(JSON.stringify(formData));
            const baseUrl = window.location.origin;
            const formLink = `${baseUrl}/bank-info?data=${encodedData}`;
            const subject = `Clanbridge Living -  Check-out Request Approved [Booking: ${bookingNo}]`;

            const Body = `Hey <strong>${residentName}</strong>,<br><br>
   We are pleased to inform you that your check-out request has been <strong>APPROVED</strong> for your tenancy at <strong>${propertyName}</strong>.<br><br>
   Following are the approved check-out details:<br><br>
   Booking No: <strong>${bookingNo}</strong><br>
   Resident Name: <strong>${residentName}</strong><br>
   Property: <strong>${propertyName}</strong><br>

   Reason: <strong>${reason}</strong><br><br>
   <a href="${formLink}" target="_blank" style="background-color: #635bff; color: white; padding: 6px 15px; text-decoration: none; border-radius: 5px; display: inline-block; margin-top: 10px;">Submit Bank Details</a><br><br>
   Your check-out has been scheduled as requested. Please ensure the following before your check-out date:<br>
   1. Clear all pending dues<br>
   2. Return all property keys and access cards<br>
   3. Complete the room inspection with our team<br>
   4. Collect your security deposit refund (if applicable)<br><br>
   Our team will contact you shortly to coordinate the check-out process and schedule the final room inspection.<br><br>
   If you have any questions or need to make changes, please contact our support team at <strong>sales@clanbridge.com</strong> or reach out to your Resident Captains.<br><br>
   We hope you had a pleasant stay with us and wish you all the best for your future endeavors!<br><br>
   Cheers,<br>
   Team Clanbridge`;

            const emailRequest = {
                ToEmail: email ? [email] : [],
                Subject: subject,
                Body: Body,
                Attachments: '',
                attachmentFilePaths: [],
                PropId: watch('PropId') || globalProperty,
                UserId: userId,
            };

            const emailResponse = await axiosInstanceForPG.post(
                `EmailRequest/SendEmail`,
                emailRequest,
            );

            if (emailResponse.data.Status === 0) {
                toast.success(`Check-out Dues email sent successfully`);
            } else {
                toast.info(emailResponse.data.Message || "Failed to send email");
            }

            return emailResponse.data.Status === 0;
        } catch (error) {
            console.error('Error sending email:', error);
            toast.error("Failed to send check-out request email");
            return false;
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <>
            <Box className="form-container">
                <ToastContainer />
                <EarlyCheckoutWarningDialog />
                <BokingCModal OpenHistoryTableDialog={OpenHistoryTableDialog} handleClose={handleClose} columns={columns} TextField={TextField} handleSearchChange={handleSearchChange} filteredRows={filteredRows} page={page} rowsPerPage={rowsPerPage} handleMobileChange={handleMobileChange} handleBookNoChange={handleBookNoChange} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />
                <Grid container spacing={3} className="rasidant_grid" >
                    <Container maxWidth="lg" spacing={1} justifyContent="center" alignItems="center">
                        <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                            <Typography variant="h5" align="center">
                                Check-Out Dues
                            </Typography>

                            <Box sx={{ position: 'absolute', right: 0, display: 'flex', gap: 1.5, alignItems: 'center' }}>
                                <Tooltip title="Send Dues Email">
                                    <Button
                                        onClick={handleSendDuesEmail}
                                        variant="contained"
                                        size="small"
                                        startIcon={<EmailIcon />}
                                        sx={{
                                            backgroundColor: '#635bff',
                                            color: 'white',
                                            borderRadius: '7px',
                                            textTransform: 'none',
                                            padding: '3px 8px',
                                            '&:hover': {
                                                backgroundColor: '#1565c0',
                                            }
                                        }}
                                    >
                                        Send Dues Email
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Print Report">
                                    <IconButton
                                        onClick={handlePrint}
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            backgroundColor: '#635bff',
                                            color: 'white',
                                            borderRadius: '7px',
                                            padding: '3px 8px',
                                            '&:hover': {
                                                backgroundColor: '#1565c0',
                                            }
                                        }}
                                    >
                                        <PrintIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Exit" arrow>
                                    <IconButton
                                        onClick={handleExitClick}
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            backgroundColor: '#635bff',
                                            color: 'white',
                                            borderRadius: '7px',
                                            padding: '3px 8px',
                                            '&:hover': {
                                                backgroundColor: '#1565c0',
                                            }
                                        }}
                                    >
                                        <CancelPresentationIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>

                            {TransactionData && TransactionData.length > 0 && TransactionData[0].BookSt === "L" && (
                                <Tooltip title="Cancel this checkout" arrow>
                                    <Box sx={{ position: 'absolute', left: 0 }}>
                                        <Button
                                            variant="contained"
                                            size="small"
                                            sx={{
                                                backgroundColor: "#e01c0dff",
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                height: 35,
                                                borderRadius: '9px',
                                                '&:hover': {
                                                    boxShadow: '0 5px 8px 2px rgba(255, 82, 82, .4)',
                                                    background: '#c52838ff'
                                                },
                                            }}
                                            onClick={handleCheckInClick}
                                        >
                                            <CancelIcon sx={{ fontSize: '18px', mr: 1 }} />
                                            Cancel
                                        </Button>
                                    </Box>
                                </Tooltip>
                            )}
                        </Box>

                        <Grid container md={12} spacing={0.5}>
                            <Grid item xs={12} md={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <OutlinedInput
                                        id="outlined-adornment-weight"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <div
                                                    style={{
                                                        width: 25,
                                                        height: 15,
                                                        backgroundImage: `url(${watch("CountryIcon")})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        borderRadius: '4px',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                />
                                            </InputAdornment>
                                        }
                                        aria-describedby="outlined-weight-helper-text"
                                        placeholder={`Enter Valid  Mobile Number`}
                                        style={{ width: "100%", height: 40 }}

                                        value={watch('MobileNo') || ''}
                                        {...register('MobileNo', { onChange: (e) => handleMobileChange(e, 'A') })}
                                        inputProps={{
                                            'aria-label': 'weight',
                                            style: { height: 40 },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="PropName"
                                    name="PropName"
                                    label="Property Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('PropName') || ''}
                                    {...register('PropName')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="ResidentName"
                                    name="ResidentName"
                                    label="First Name"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('ResidentName') || ''}
                                    {...register('ResidentName')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="ChkOutStlNo"
                                    name="ChkOutStlNo"
                                    label="Settlement No"
                                    variant="filled"
                                    value={checkoutSettlementData?.ChkOutStlNo || ""}
                                    fullWidth
                                    className="custom-textfield"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>
                            {/* <Grid item xs={12} md={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={
                                            <>
                                                Settelment Date <span style={{ color: 'red' }}>*</span>
                                            </>
                                        }
                                        value={watch('ChkOutStlDt') ? dayjs(watch('CheckedOutDt'), 'DD/MM/YYYY') : dayjs()}
                                        onChange={(newValue) => {
                                            if (newValue) {
                                                const formattedDate = newValue.format('DD/MM/YYYY');
                                                setValue('CheckedOutDt', formattedDate);
                                                setSelectedCheckoutDate(formattedDate);
                                            } else {
                                                const today = dayjs().format('DD/MM/YYYY');
                                                setValue('CheckedOutDt', today);
                                                setSelectedCheckoutDate(today);
                                            }
                                        }}
                                        minDate={dayjs(watch('CheckinDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])}
                                        format="DD/MM/YYYY"
                                        slotProps={{
                                            textField: {
                                                variant: 'filled',
                                                fullWidth: true,
                                                className: 'custom-textfield',
                                                error: !watch('CheckedOutDt'),
                                                helperText: !watch('CheckedOutDt') ? "Checkout date is required" : ""
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid> */}

                            <Grid item xs={12} md={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={
                                            <>
                                                Settlement Date <span style={{ color: 'red' }}>*</span>
                                            </>
                                        }
                                        value={dayjs(settlementDate, 'DD/MM/YYYY')}
                                        onChange={(newValue) => {
                                            if (newValue && newValue.isValid()) {
                                                const formattedDate = newValue.format('DD/MM/YYYY');
                                                setSettlementDate(formattedDate);  // Store settlement date separately

                                                // Check if the date was actually changed by user
                                                if (settlementDate !== formattedDate && !isInitialLoad.current) {
                                                    const originalCheckout = dayjs(watch('BookUpToDt'), ['DD/MM/YYYY', 'YYYY-MM-DD']);
                                                    if (originalCheckout.isValid()) {
                                                        const diffDays = originalCheckout.diff(newValue, 'day');
                                                        if (diffDays > 30) {
                                                            setShowEarlyCheckoutWarning(true);
                                                        } else {
                                                            setShowEarlyCheckoutWarning(false);
                                                        }
                                                    }
                                                }
                                            } else {
                                                // Fallback to today's date if no date selected
                                                const today = dayjs().format('DD/MM/YYYY');
                                                setSettlementDate(today);
                                            }
                                        }}
                                        minDate={dayjs(watch('CheckinDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])}
                                        format="DD/MM/YYYY"
                                        slotProps={{
                                            textField: {
                                                variant: 'filled',
                                                fullWidth: true,
                                                className: 'custom-textfield',
                                                error: !settlementDate,
                                                helperText: !settlementDate ? "Settlement date is required" : ""
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="BookNo"
                                    name="BookNo"
                                    label="Book No"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('BookNo') || ''}
                                    {...register('BookNo', { onChange: (e) => handleBookNoChange(e, 'A') })}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="BookDt"
                                    name="BookDt"
                                    label="Book Date"
                                    variant="filled"
                                    // type="date"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formatDate(watch('BookDt'))}
                                    {...register('BookDt')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="Duration"
                                    name="Duration"
                                    label="Duration"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={watch('Duration') || ''}
                                    {...register('Duration')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="CheckinDt"
                                    name="CheckinDt"
                                    // type="date"
                                    label="Checkin Date"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formatDate(watch('CheckinDt'))}
                                    {...register('CheckinDt')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="BookUpToDt"
                                    name="BookUpToDt"
                                    label="Checkout Date"
                                    // type="date"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formatDate(watch('BookUpToDt'))}
                                    {...register('BookUpToDt')}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={true}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} sx={{ display: "flex", justifyContent: { xs: 'flex-end', md: 'flex-start' }, alignItems: 'center' }}>
                                <Tooltip title='Get booking details data' arrow>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        sx={{
                                            backgroundColor: "#635bff",
                                            height: 35,
                                            whiteSpace: 'nowrap',
                                            textOverflow: 'ellipsis',
                                            overflow: 'hidden',
                                            borderRadius: '9px'
                                        }}
                                        onClick={handleClickCheckAva}
                                    >
                                        Get Data
                                    </Button>
                                </Tooltip>

                            </Grid>
                        </Grid>
                        <hr></hr>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={2}>
                                <Typography variant="h6" gutterBottom >
                                    Room Details
                                </Typography>
                            </Grid>
                            {/* Work Info Column */}
                            <Grid item xs={12} sm={10}>
                                <Grid container spacing={1} >
                                    <Grid item xs={6} md={2} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
                                        <TextField
                                            id="WingName"
                                            name="WingName"
                                            label="Wing"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('WingName') || ''}
                                            {...register('WingName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
                                        <TextField
                                            id="FloorName"
                                            name="FloorName"
                                            label="Floor"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('FloorName') || ''}
                                            {...register('FloorName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2}>
                                        <TextField
                                            id="RoomTypeName"
                                            name="RoomTypeName"
                                            label="Room Type"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('RoomTypeName') || ''}
                                            {...register('RoomTypeName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2}>
                                        <TextField
                                            id="RoombedName"
                                            name="RoombedName"
                                            label="Bed No"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('RoombedName') || ''}
                                            {...register('RoombedName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2}>
                                        <TextField
                                            id="RoomBedTypeName"
                                            name="RoomBedTypeName"
                                            label="Bed Type"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={watch('RoomBedTypeName') || ''}
                                            {...register('RoomBedTypeName')}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>

                                    <Grid item xs={6} md={2}>
                                        <TextField
                                            id="BedRent"
                                            name="BedRent"
                                            label="Standard Rent"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            {...register('BedRent')}
                                            value={watch('BedRent') || ''}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <hr></hr>
                        <Grid container spacing={1} sx={{ mt: 1, display: { xs: 'none', sm: 'none' } }}>
                            <Grid item xs={12} sm={2}>
                                <Typography variant="h6" gutterBottom >
                                    Outstanding Amount
                                </Typography>
                            </Grid>

                            {/* Work Info Column */}
                            <Grid item xs={12} sm={10} >
                                <Grid container spacing={1}  >
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            id="TopupAmt"
                                            name="TopupAmt"
                                            label="Outstanding Amount"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            {...register('TopupAmt')}
                                            value={watch('TopupAmt') || ''}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            id="TAmount"
                                            name="TAmount"
                                            label="Transport Service"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            {...register('TAmount')}
                                            value={watch('TAmount') || ''}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            id="MAmount"
                                            name="MAmount"
                                            label="Mess Service"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            {...register('MAmount')}
                                            value={watch('MAmount') || ''}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                {/* </Paper> */}
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} sx={{ display: { xs: '', sm: 'flex' } }}>
                            <Grid container spacing={1} sx={{ marginLeft: '0px' }} >
                                <Grid item xs={12} sm={12} md={6} display="flex" alignItems="center">
                                    <Typography variant="p" gutterBottom sx={{ mr: 1 }}>
                                        Booking Status:
                                    </Typography>
                                    {TransactionData && TransactionData?.length > 0 ? (
                                        <Typography
                                            component="span"
                                            style={{
                                                color: TransactionData[0].BookSt === "C" ? "green" :
                                                    TransactionData[0].BookSt === "B" ? "blue" :
                                                        TransactionData[0].BookSt === "O" ? "orange" : "red",
                                                fontWeight: "bold",
                                                marginLeft: "8px",
                                                fontSize: '14px'
                                            }}
                                        >
                                            {TransactionData[0].BookSt === "C"
                                                ? "Confirmed"
                                                : TransactionData[0].BookSt === "B"
                                                    ? "Booked"
                                                    : TransactionData[0].BookSt === "O"
                                                        ? "CheckedIn"
                                                        : TransactionData[0].BookSt === "L"
                                                            ? "CheckOut"
                                                            : TransactionData[0].BookSt === "X"
                                                                ? "Cancelled"
                                                                : "Unknown"}
                                        </Typography>
                                    ) : (
                                        <Typography variant="body1" sx={{ color: 'gray', fontWeight: 'bold' }}>
                                            Not Found
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid container spacing={1.5} sx={{ marginLeft: '0px', alignItems: 'center' }}>
                                <Grid item xs={6} md={2.3} lg={2.3} className="form_field">
                                    <Autocomplete
                                        options={OthChrgDrp}
                                        id="OthChrgId-autocomplete"
                                        value={selectedCharge}
                                        onChange={handleChargeChange}
                                        getOptionLabel={(option) => option?.Name || ""}
                                        isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
                                        disableClearable
                                        popupIcon={null}
                                        clearIcon={null}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="filled"
                                                label="Other Charges"
                                                placeholder="Select charge"
                                                fullWidth
                                                className="custom-textfield"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            <Tooltip title="Add New" arrow>
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        onClick={openOth}
                                                                        edge="end"
                                                                        size="small"
                                                                        sx={{
                                                                            color: '#635bff',
                                                                            marginRight: '-35px',
                                                                            '&:hover': {
                                                                                backgroundColor: 'rgba(99, 91, 255, 0.08)',
                                                                            }
                                                                        }}
                                                                    >
                                                                        <AddIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            </Tooltip>
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                    disableUnderline: true,
                                                }}
                                                sx={{
                                                    '& .MuiInputLabel-root': {
                                                        fontSize: '0.875rem',
                                                        transform: 'translate(12px, 10px) scale(1)',
                                                        '&.Mui-focused': {
                                                            transform: 'translate(12px, 6px) scale(0.75)',
                                                            color: '#673ab7'
                                                        },
                                                        '&.MuiFormLabel-filled': {
                                                            transform: 'translate(12px, 6px) scale(0.75)'
                                                        }
                                                    },
                                                    '& .MuiFilledInput-root': {
                                                        height: '38px',
                                                        minHeight: '38px',
                                                        backgroundColor: "transparent",
                                                        border: "1px solid #e0e0e0",
                                                        borderRadius: "6px",
                                                        '&:hover': {
                                                            borderColor: "#b3b3b3",
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            padding: '8px 12px 8px',
                                                            fontSize: '0.875rem'
                                                        }
                                                    },
                                                    '& .MuiFilledInput-root.Mui-focused': {
                                                        border: "1px solid #673ab7",
                                                        boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
                                                    },
                                                }}
                                            />
                                        )}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.Id}>
                                                {option.Name}
                                            </li>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6} md={1.4} lg={1.4} className="form_field">
                                    <TextField
                                        label="Amount"
                                        type="number"
                                        variant="filled"
                                        className="custom-textfield"
                                        fullWidth
                                        value={amount}
                                        onChange={(e) => setAmount(e.target.value)}
                                        sx={{
                                            '& .MuiInputLabel-root': {
                                                fontSize: '0.875rem',
                                                transform: 'translate(12px, 10px) scale(1)',
                                                '&.Mui-focused': {
                                                    transform: 'translate(12px, 6px) scale(0.75)',
                                                    color: '#673ab7'
                                                },
                                                '&.MuiFormLabel-filled': {
                                                    transform: 'translate(12px, 6px) scale(0.75)'
                                                }
                                            },
                                            '& .MuiFilledInput-root': {
                                                height: '38px',
                                                minHeight: '38px',
                                                backgroundColor: "transparent",
                                                border: "1px solid #e0e0e0",
                                                borderRadius: "6px",
                                                '&:hover': {
                                                    borderColor: "#b3b3b3",
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '8px 12px 8px',
                                                    fontSize: '0.875rem'
                                                }
                                            },
                                            '& .MuiFilledInput-root.Mui-focused': {
                                                border: "1px solid #673ab7",
                                                boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={6} md={1.4} lg={1.4} className="form_field">
                                    <TextField
                                        label="Discount"
                                        type="number"
                                        variant="filled"
                                        className="custom-textfield"
                                        fullWidth
                                        value={discount}
                                        onChange={(e) => setDiscount(e.target.value)}
                                        sx={{
                                            '& .MuiInputLabel-root': {
                                                fontSize: '0.875rem',
                                                transform: 'translate(12px, 10px) scale(1)',
                                                '&.Mui-focused': {
                                                    transform: 'translate(12px, 6px) scale(0.75)',
                                                    color: '#673ab7'
                                                },
                                                '&.MuiFormLabel-filled': {
                                                    transform: 'translate(12px, 6px) scale(0.75)'
                                                }
                                            },
                                            '& .MuiFilledInput-root': {
                                                height: '38px',
                                                minHeight: '38px',
                                                backgroundColor: "transparent",
                                                border: "1px solid #e0e0e0",
                                                borderRadius: "6px",
                                                '&:hover': {
                                                    borderColor: "#b3b3b3",
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '8px 12px 8px',
                                                    fontSize: '0.875rem'
                                                }
                                            },
                                            '& .MuiFilledInput-root.Mui-focused': {
                                                border: "1px solid #673ab7",
                                                boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} md={1.4} lg={1.4} className="form_field">
                                    <TextField
                                        label="Net Amount"
                                        type="number"
                                        variant="filled"
                                        fullWidth
                                        className="custom-textfield"
                                        value={totalAmount}
                                        onChange={(e) => setTotalAmount(e.target.value)}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        sx={{
                                            '& .MuiInputLabel-root': {
                                                fontSize: '0.875rem',
                                                transform: 'translate(12px, 10px) scale(1)',
                                                '&.Mui-focused': {
                                                    transform: 'translate(12px, 6px) scale(0.75)',
                                                    color: '#673ab7'
                                                },
                                                '&.MuiFormLabel-filled': {
                                                    transform: 'translate(12px, 6px) scale(0.75)'
                                                }
                                            },
                                            '& .MuiFilledInput-root': {
                                                height: '38px',
                                                minHeight: '38px',
                                                backgroundColor: "#f8f9fa",
                                                border: "1px solid #e0e0e0",
                                                borderRadius: "6px",
                                                '& .MuiInputBase-input': {
                                                    padding: '8px 12px 8px',
                                                    fontSize: '0.875rem',
                                                    color: '#666'
                                                }
                                            },
                                            '& .MuiFilledInput-root.Mui-focused': {
                                                border: "1px solid #673ab7",
                                                boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} md={2.5} lg={2.5} className="form_field">
                                    <TextField
                                        label="Remark"
                                        type="text"
                                        variant="filled"
                                        className="custom-textfield"
                                        fullWidth
                                        value={remark}
                                        onChange={(e) => setRemark(e.target.value)}
                                        sx={{
                                            '& .MuiInputLabel-root': {
                                                fontSize: '0.875rem',
                                                transform: 'translate(12px, 10px) scale(1)',
                                                '&.Mui-focused': {
                                                    transform: 'translate(12px, 6px) scale(0.75)',
                                                    color: '#673ab7'
                                                },
                                                '&.MuiFormLabel-filled': {
                                                    transform: 'translate(12px, 6px) scale(0.75)'
                                                }
                                            },
                                            '& .MuiFilledInput-root': {
                                                height: '38px',
                                                minHeight: '38px',
                                                backgroundColor: "transparent",
                                                border: "1px solid #e0e0e0",
                                                borderRadius: "6px",
                                                '&:hover': {
                                                    borderColor: "#b3b3b3",
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '8px 12px 8px',
                                                    fontSize: '0.875rem'
                                                }
                                            },
                                            '& .MuiFilledInput-root.Mui-focused': {
                                                border: "1px solid #673ab7",
                                                boxShadow: "0 0 0 2px rgba(103, 58, 183, 0.1)",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={3} lg={3} className="form_field">
                                    <Box display="flex" flexDirection="row" gap={1}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleAddCharge}
                                            disabled={!isButtondisable}
                                            sx={{
                                                height: '38px',
                                                minHeight: '38px',
                                                borderRadius: '6px',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                fontSize: '0.875rem',
                                                boxShadow: 'none',
                                                '&:hover': {
                                                    boxShadow: '0 2px 6px rgba(103, 58, 183, 0.3)',
                                                }
                                            }}
                                        >
                                            Add Charge
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={handleCalculateCharges}
                                            // disabled={!isButtondisable || isPenaltyCalculated }
                                            sx={{
                                                height: '38px',
                                                minHeight: '38px',
                                                borderRadius: '6px',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                fontSize: '0.875rem',
                                                backgroundColor: '#ff6347',
                                                '&:hover': {
                                                    backgroundColor: '#ff4500',
                                                    boxShadow: '0 2px 6px rgba(255, 69, 0, 0.3)',
                                                },
                                                '&.Mui-disabled': {
                                                    backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                                    color: 'rgba(0, 0, 0, 0.26)',
                                                }
                                            }}
                                        >
                                            Calc Dues
                                        </Button>
                                        <IconButton
                                            size="small"
                                            color="error"
                                            onClick={() => setOpenCheckinConfirm(true)}
                                            disabled={otherChargesList.length === 0}
                                            sx={{
                                                height: '37px',
                                                minHeight: '37px',
                                                borderRadius: '6px',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                backgroundColor: 'red',
                                                '&:hover': {
                                                    backgroundColor: '#F5310C',
                                                },
                                            }}
                                        >
                                            <DeleteIcon sx={{
                                                fontSize: { xs: '16px', sm: '18px' },
                                                color: '#f5ededff'
                                            }} />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        {otherChargesList?.length > 0 && (
                            <Grid container sx={{ mt: 1 }}>
                                <Grid item xs={12}>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        sx={{
                                            mb: 1,
                                            fontSize: { xs: '0.85rem', sm: '0.95rem' },
                                            fontWeight: 'bold',
                                            color: '#1976d2',
                                            background: 'lightgray',
                                            padding: { xs: '6px 8px', sm: '8px 12px' },
                                            borderRadius: '4px',
                                            borderLeft: '4px solid #1976d2'
                                        }}
                                    >
                                        💰 Added Charges & Refunds
                                    </Typography>
                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            maxHeight: 170,
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            background: 'linear(145deg, #ffffff, #fafafa)',
                                            overflowX: 'auto'
                                        }}
                                    >
                                        <Table
                                            stickyHeader
                                            size="small"
                                            sx={{
                                                minWidth: 650,
                                                '& .MuiTableCell-root': {
                                                    padding: { xs: '2px 4px', sm: '4px 6px' },
                                                    border: '1px solid #e0e0e0',
                                                    lineHeight: '1.2'
                                                },
                                                '& .MuiTableHead-root .MuiTableCell-root': {
                                                    background: 'linear(45deg, #667eea 0%, #764ba2 100%)',
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                    padding: { xs: '4px 6px', sm: '6px 8px' },
                                                    borderBottom: '2px solid #5a6fd8',
                                                    whiteSpace: 'nowrap'
                                                },
                                                '& .MuiTableBody-root .MuiTableCell-root': {
                                                    fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                    padding: { xs: '2px 4px', sm: '4px 6px' },
                                                    whiteSpace: 'nowrap'
                                                },
                                                '& .MuiTableRow-root': {
                                                    height: { xs: '28px', sm: '32px' }
                                                }
                                            }}
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{
                                                        width: { xs: '35%', sm: '35%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }}>Charge/Refund Name</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '15%', sm: '15%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }} align="right">Amount</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '15%', sm: '15%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }} align="right">Discount</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '20%', sm: '20%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }} align="right">Net Amount</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '15%', sm: '15%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }} align="center">Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {otherChargesList
                                                    .filter(charge => !charge.isNegative && charge.netAmount >= 0)
                                                    .map((charge) => (
                                                        <TableRow
                                                            key={charge.ChkOutStlDtlId || charge.id}
                                                            sx={{
                                                                height: { xs: '28px', sm: '32px' },
                                                                '&:nth-of-type(odd)': {
                                                                    backgroundColor: '#f8fbff'
                                                                },
                                                                '&:nth-of-type(even)': {
                                                                    backgroundColor: '#ffffff'
                                                                },
                                                                '&:hover': {
                                                                    backgroundColor: '#f0f7ff'
                                                                }
                                                            }}
                                                        >
                                                            <TableCell sx={{
                                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                                fontWeight: 'bold',
                                                                color: '#1565c0',
                                                                fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                            }}>
                                                                {charge.ChrgName || charge.chargeName}
                                                            </TableCell>
                                                            <TableCell sx={{
                                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                                fontWeight: 'bold',
                                                                color: '#2e7d32',
                                                                fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                            }} align="right">
                                                                ₹{charge.ChrgAmt || charge.amount}
                                                            </TableCell>
                                                            <TableCell sx={{
                                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                                fontWeight: 'bold',
                                                                color: '#ff9800',
                                                                fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                            }} align="right">
                                                                ₹{charge.DiscAmt || charge.discount}
                                                            </TableCell>
                                                            <TableCell sx={{
                                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                                fontWeight: 'bold',
                                                                color: '#1976d2',
                                                                fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                            }} align="right">
                                                                ₹{Math.abs(charge.NetAmt || charge.netAmount)}
                                                            </TableCell>
                                                            <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                                                                <IconButton
                                                                    size="small"
                                                                    color="error"
                                                                    onClick={() => handleDeleteCharge(charge.id)}
                                                                    sx={{
                                                                        padding: '2px',
                                                                        '&:hover': {
                                                                            backgroundColor: 'rgba(211, 47, 47, 0.1)',
                                                                            transform: 'scale(1.1)',
                                                                            transition: 'transform 0.2s ease'
                                                                        },
                                                                        height: { xs: '20px', sm: '22px' },
                                                                        width: { xs: '20px', sm: '22px' }
                                                                    }}
                                                                >
                                                                    <DeleteIcon sx={{
                                                                        fontSize: { xs: '14px', sm: '16px' },
                                                                        color: '#d32f2f'
                                                                    }} />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }

                                                {otherChargesList
                                                    .filter(charge => charge.isNegative || charge.netAmount < 0)
                                                    .map((charge) => (
                                                        <TableRow
                                                            key={charge.ChkOutStlDtlId || charge.id}
                                                            sx={{
                                                                height: { xs: '28px', sm: '32px' },
                                                                backgroundColor: '#fff8f8',
                                                                '&:hover': {
                                                                    backgroundColor: '#ffeaea'
                                                                }
                                                            }}
                                                        >
                                                            <TableCell sx={{
                                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                                fontWeight: 'bold',
                                                                color: '#d32f2f',
                                                                fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                            }}>
                                                                {charge.ChrgName || charge.chargeName} (Refund)
                                                            </TableCell>
                                                            <TableCell sx={{
                                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                                fontWeight: 'bold',
                                                                color: '#d32f2f',
                                                                fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                            }} align="right">
                                                                ₹{charge.ChrgAmt || charge.amount}
                                                            </TableCell>
                                                            <TableCell sx={{
                                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                                fontWeight: 'bold',
                                                                color: '#ff9800',
                                                                fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                            }} align="right">
                                                                ₹{charge.DiscAmt || charge.discount}
                                                            </TableCell>
                                                            <TableCell sx={{
                                                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                                                fontWeight: 'bold',
                                                                color: '#d32f2f',
                                                                fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                            }} align="right">
                                                                - ₹{Math.abs(charge.NetAmt || charge.netAmount)}
                                                            </TableCell>
                                                            <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                                                                <IconButton
                                                                    size="small"
                                                                    color="error"
                                                                    onClick={() => handleDeleteCharge(charge.id)}
                                                                    sx={{
                                                                        padding: '2px',
                                                                        '&:hover': {
                                                                            backgroundColor: 'rgba(211, 47, 47, 0.1)',
                                                                            transform: 'scale(1.1)',
                                                                            transition: 'transform 0.2s ease'
                                                                        },
                                                                        height: { xs: '20px', sm: '22px' },
                                                                        width: { xs: '20px', sm: '22px' }
                                                                    }}
                                                                >
                                                                    <DeleteIcon sx={{
                                                                        fontSize: { xs: '14px', sm: '16px' },
                                                                        color: '#d32f2f'
                                                                    }} />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }

                                                {/* Total Row */}
                                                <TableRow sx={{
                                                    backgroundColor: '#f8f9fa',
                                                    height: { xs: '28px', sm: '32px' },
                                                    '&:hover': {
                                                        backgroundColor: totalChargesAmount < 0 ? '#ffebee' : '#e8f5e9'
                                                    }
                                                }}>
                                                    <TableCell
                                                        colSpan={3}
                                                        align="right"
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                            padding: { xs: '2px 4px', sm: '4px 6px' },
                                                            color: totalChargesAmount < 0 ? '#d32f2f' : '#2e7d32'
                                                        }}
                                                    >
                                                        Net Total:
                                                    </TableCell>
                                                    <TableCell
                                                        align="right"
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                            padding: { xs: '2px 4px', sm: '4px 6px' },
                                                            color: totalChargesAmount < 0 ? '#d32f2f' : '#2e7d32',
                                                            borderLeft: `2px solid ${totalChargesAmount < 0 ? '#f44336' : '#4caf50'}`
                                                        }}
                                                    >
                                                        {totalChargesAmount < 0 ? '- ' : ''}₹{Math.abs(totalChargesAmount)}
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                                        background: totalChargesAmount < 0 ?
                                                            'linear(45deg, #f44336, #ef5350)' :
                                                            'linear(45deg, #4caf50, #66bb6a)'
                                                    }}></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12} sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    mt: 1,
                                    gap: 1
                                }}>
                                    <Typography
                                        sx={{
                                            fontWeight: 'bold',
                                            color: totalChargesAmount < 0 ? '#d32f2f' : '#2e7d32',
                                            fontSize: '1rem'
                                        }}
                                    >
                                        {totalChargesAmount < 0 ? 'TOTAL REFUND :' : 'TOTAL PAYABLE :'}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: 'bold',
                                            color: totalChargesAmount < 0 ? '#d32f2f' : '#2e7d32',
                                            fontSize: '1rem',
                                            minWidth: '80px'
                                        }}
                                    >
                                        {totalChargesAmount < 0 ? '- ' : ''}₹{Math.abs(totalChargesAmount)}
                                    </Typography>
                                    {totalChargesAmount > 0 ? (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleCalculate}
                                            size='small'
                                        >
                                            Calc Settlement advice
                                        </Button>
                                    ) : ""}

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmitdata}
                                        size='small'
                                        disabled={isSubmitting || otherChargesList.length === 0}
                                        sx={{
                                            position: 'relative',
                                            '&:disabled': {
                                                backgroundColor: '#cccccc',
                                                color: '#666666'
                                            }
                                        }}
                                    >
                                        {isSubmitting ? (
                                            <>
                                               
                                                Submitted...
                                            </>
                                        ) : (
                                            'Submit'
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>
                        )}
                        {showPayAdvice && payAdvice.length > 0 && (
                            <Grid container sx={{ mt: 1 }}>
                                <Grid item xs={12}>
                                    <Typography
                                        variant="h6"
                                        gutterBottom
                                        sx={{
                                            mb: 1,
                                            fontSize: { xs: '0.85rem', sm: '0.95rem' },
                                            fontWeight: 'bold',
                                            color: '#1976d2',
                                            background: 'lightgray',
                                            padding: { xs: '6px 8px', sm: '8px 12px' },
                                            borderRadius: '4px',
                                            borderLeft: '4px solid #1976d2'
                                        }}
                                    >
                                        💰 Payment Advice Details
                                    </Typography>
                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            maxHeight: 200,
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            background: 'linear(145deg, #ffffff, #fafafa)',
                                            overflowX: 'auto'
                                        }}
                                    >
                                        <Table
                                            stickyHeader
                                            size="small"
                                            sx={{
                                                minWidth: 650,
                                                '& .MuiTableCell-root': {
                                                    padding: { xs: '2px 4px', sm: '4px 6px' },
                                                    border: '1px solid #e0e0e0',
                                                    lineHeight: '1.2'
                                                },
                                                '& .MuiTableHead-root .MuiTableCell-root': {
                                                    background: 'linear(45deg, #667eea 0%, #764ba2 100%)',
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                    padding: { xs: '4px 6px', sm: '6px 8px' },
                                                    borderBottom: '2px solid #5a6fd8',
                                                    whiteSpace: 'nowrap'
                                                },
                                                '& .MuiTableBody-root .MuiTableCell-root': {
                                                    fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                                    padding: { xs: '2px 4px', sm: '4px 6px' },
                                                    whiteSpace: 'nowrap'
                                                },
                                                '& .MuiTableRow-root': {
                                                    height: { xs: '28px', sm: '32px' },
                                                    cursor: 'pointer'
                                                }
                                            }}
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{
                                                        width: { xs: '12%', sm: '10%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }}>AdvNo</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '10%', sm: '8%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }}>AdvDt</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '12%', sm: '10%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }}>AdviceFor</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '10%', sm: '8%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }} align="right">AdvAmt</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '10%', sm: '8%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }} align="right">RcdAmt</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '10%', sm: '8%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }} align="right">Balance</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '10%', sm: '8%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }} align="center">DueDays</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '10%', sm: '8%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }}>RecDt</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '14%', sm: '12%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }}>Remark</TableCell>
                                                    <TableCell sx={{
                                                        width: { xs: '22%', sm: '20%' },
                                                        background: '#d7dbd1ff !important',
                                                        color: 'black !important'
                                                    }} align="center">Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {payAdvice?.map((item, index) => (
                                                    <TableRow
                                                        key={index}
                                                        sx={{
                                                            height: { xs: '25px', sm: '28px' },
                                                            '&:nth-of-type(odd)': {
                                                                backgroundColor: '#f8fbff'
                                                            },
                                                            '&:nth-of-type(even)': {
                                                                backgroundColor: '#ffffff'
                                                            },
                                                            '&:hover': {
                                                                backgroundColor: '#f0f7ff'
                                                            }
                                                        }}
                                                        onDoubleClick={() => {
                                                            const url = `/advicegeneratetable?PytAdvId=${item.PytAdvId}`;
                                                            window.open(url, '_blank');
                                                        }}
                                                    >
                                                        <TableCell sx={{
                                                            padding: { xs: '2px 4px', sm: '4px 6px' },
                                                            fontWeight: 'bold',
                                                            color: '#1565c0',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                        }}>
                                                            {item?.PytAdvNo}
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            padding: { xs: '2px 4px', sm: '4px 6px' },
                                                            color: '#666',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                        }}>
                                                            {moment(item?.PytAdvDt).format("DD-MM-YYYY")}
                                                        </TableCell>
                                                        <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }}>
                                                            <Chip
                                                                label={
                                                                    item?.PytAdvFor === "D" ? "Deposit" :
                                                                        item?.PytAdvFor === "R" ? "Rent" :
                                                                            item?.PytAdvFor === "O" ? "Other" :
                                                                                item?.PytAdvFor === "T" ? "TopUp" : ""
                                                                }
                                                                size="small"
                                                                sx={{
                                                                    fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                                                    height: { xs: '16px', sm: '18px' },
                                                                    fontWeight: 'bold',
                                                                    backgroundColor:
                                                                        item?.PytAdvFor === "D" ? '#e8f5e9' :
                                                                            item?.PytAdvFor === "R" ? '#fff3e0' :
                                                                                item?.PytAdvFor === "O" ? '#f3e5f5' :
                                                                                    '#e1f5fe',
                                                                    color:
                                                                        item?.PytAdvFor === "D" ? '#2e7d32' :
                                                                            item?.PytAdvFor === "R" ? '#ef6c00' :
                                                                                item?.PytAdvFor === "O" ? '#7b1fa2' :
                                                                                    '#0277bd'
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            padding: { xs: '2px 4px', sm: '4px 6px' },
                                                            fontWeight: 'bold',
                                                            color: '#2e7d32',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                        }} align="right">
                                                            ₹{item?.Amount}
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            padding: { xs: '2px 4px', sm: '4px 6px' },
                                                            fontWeight: 'bold',
                                                            color: '#1976d2',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                        }} align="right">
                                                            ₹{item?.RcdAmt || '0'}
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            padding: { xs: '2px 4px', sm: '4px 6px' },
                                                            fontWeight: 'bold',
                                                            color: item?.BalAmount > 0 ? '#d32f2f' : '#2e7d32',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                        }} align="right">
                                                            ₹{item?.BalAmount}
                                                        </TableCell>
                                                        <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                                                            <Chip
                                                                label={item?.DueDays}
                                                                size="small"
                                                                sx={{
                                                                    fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                                                    height: { xs: '16px', sm: '18px' },
                                                                    fontWeight: 'bold',
                                                                    color: 'white',
                                                                    backgroundColor:
                                                                        item?.DueDays === 0 ? '#4caf50' :
                                                                            item?.DueDays <= 7 ? '#ff9800' :
                                                                                item?.DueDays <= 30 ? '#f44336' :
                                                                                    '#d32f2f'
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            padding: { xs: '2px 4px', sm: '4px 6px' },
                                                            color: '#666',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                        }}>
                                                            {item?.RecDt ? moment(item.RecDt).format("DD-MM-YYYY") : "-"}
                                                        </TableCell>
                                                        <TableCell sx={{
                                                            padding: { xs: '2px 4px', sm: '4px 6px' },
                                                            color: '#666',
                                                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                                        }}>
                                                            {item?.Remark || "-"}
                                                        </TableCell>
                                                        <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                                                            {item?.PaymentSt && (
                                                                <Chip
                                                                    label={item.PaymentSt}
                                                                    size="small"
                                                                    sx={{
                                                                        fontWeight: 'bold',
                                                                        color: 'white',
                                                                        backgroundColor:
                                                                            item.PaymentSt.toLowerCase() === 'paid' ? '#4CAF50' :
                                                                                item.PaymentSt.toLowerCase() === 'partial' ? '#FF9800' :
                                                                                    '#F44336',
                                                                        marginRight: item.PaymentSt.toLowerCase() !== 'paid' ? '4px' : 0,
                                                                        fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                                                        height: { xs: '18px', sm: '20px' },
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                                                    }}
                                                                />
                                                            )}
                                                            {item?.PaymentSt?.toLowerCase() !== 'paid' && (
                                                                <Box sx={{
                                                                    display: 'inline-flex',
                                                                    gap: 0.5,
                                                                    ml: 0.5,
                                                                    flexWrap: { xs: 'wrap', sm: 'nowrap' }
                                                                }}>
                                                                    <Button
                                                                        variant="contained"
                                                                        size="small"
                                                                        color="primary"
                                                                        onClick={() => handleSendPaymentLink(item)}
                                                                        sx={{
                                                                            padding: { xs: '1px 6px', sm: '2px 8px' },
                                                                            minWidth: 'auto',
                                                                            fontSize: { xs: '0.55rem', sm: '0.6rem' },
                                                                            height: { xs: '20px', sm: '22px' },
                                                                            background: 'linear(45deg, #2196F3, #21CBF3)',
                                                                            boxShadow: '0 1px 3px rgba(33, 150, 243, 0.3)',
                                                                            '&:hover': {
                                                                                background: 'linear(45deg, #1976D2, #00B0FF)',
                                                                                boxShadow: '0 2px 5px rgba(33, 150, 243, 0.4)'
                                                                            }
                                                                        }}
                                                                    >
                                                                        {loadingPaymentLinks[item.PytAdvId] ? (
                                                                            <CircularProgress size={10} sx={{ color: 'white' }} />
                                                                        ) : (
                                                                            '💳 Pay'
                                                                        )}
                                                                    </Button>

                                                                    <Tooltip title="Refresh Data" arrow>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => fetchPayAdvice(BookId)}
                                                                            sx={{
                                                                                padding: '2px',
                                                                                '&:hover': {
                                                                                    backgroundColor: 'rgba(255, 152, 0, 0.1)',
                                                                                    transform: 'rotate(90deg)',
                                                                                    transition: 'transform 0.3s ease'
                                                                                },
                                                                                height: { xs: '20px', sm: '22px' },
                                                                                width: { xs: '20px', sm: '22px' }
                                                                            }}
                                                                        >
                                                                            <RefreshIcon sx={{
                                                                                fontSize: { xs: '12px', sm: '14px' },
                                                                                color: '#FF9800',
                                                                                fontWeight: 'bold'
                                                                            }} />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Box>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        )}

                        {showPayAdvice && pendingAdvice.length > 0 && (
                            <UnbuildAdvice
                                pendingAdvice={pendingAdvice}
                                loadingPaymentLinks={loadingPaymentLinks}
                                fetchPendingAdvice={fetchPendingAdvice}
                                BookId={BookId}
                                handleSendPaymentLink={handleSendPaymentLink}
                            />
                        )}
                    </Container>
                    <div style={{ display: 'none' }}>
                        {<PrintCharges
                            contentRef={contentRef}
                            DataObj={watch()}
                            otherChargesList={otherChargesList}
                            totalChargesAmount={totalChargesAmount}
                            checkoutSettlementData={checkoutSettlementData}
                        />
                        }
                    </div>
                    <ConfirmationDialog
                        open={openCheckoutConfirm}
                        onClose={() => setOpenCheckoutConfirm(false)}
                        onConfirm={handleCheckoutConfirm}
                        title="Confirm Checkout"
                        message="Are you sure you want to checkout this booking?"
                    />
                    <ConfirmationDialog
                        open={openCheckinConfirm}
                        onClose={() => setOpenCheckinConfirm(false)}
                        onConfirm={handleDeleteCharges}
                        title="Delete Charges"
                        message="Are you sure you want to delete all charges ?"
                    />

                </Grid>
            </Box >
        </>
    )
}

export default Checkoutdues;